[
  {
    "tag": "1",
    "name": "Account",
    "type": "String",
    "description": "Account mnemonic as agreed between broker and institution."
  },
  {
    "tag": "2",
    "name": "AdvId",
    "type": "String",
    "description": "Unique identifier of advertisement message.\n(Prior to FIX 4.1 this field was of type int)"
  },
  {
    "tag": "3",
    "name": "AdvRefID",
    "type": "String",
    "description": "Reference identifier used with CANCEL and REPLACE transaction types.\n(Prior to FIX 4.1 this field was of type int)"
  },
  {
    "tag": "4",
    "name": "AdvSide",
    "type": "char",
    "description": "Broker's side of advertised trade",
    "enum": [
      {
        "value": "B",
        "symbolicName": "Buy",
        "description": "Buy"
      },
      {
        "value": "S",
        "symbolicName": "Sell",
        "description": "Sell"
      },
      {
        "value": "T",
        "symbolicName": "Trade",
        "description": "Trade"
      },
      {
        "value": "X",
        "symbolicName": "Cross",
        "description": "Cross"
      }
    ]
  },
  {
    "tag": "5",
    "name": "AdvTransType",
    "type": "String",
    "description": "Identifies advertisement message transaction type",
    "enum": [
      {
        "value": "C",
        "symbolicName": "Cancel",
        "description": "Cancel"
      },
      {
        "value": "N",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "R",
        "symbolicName": "Replace",
        "description": "Replace"
      }
    ]
  },
  {
    "tag": "6",
    "name": "AvgPx",
    "type": "Price",
    "description": "Calculated average price of all fills on this order."
  },
  {
    "tag": "7",
    "name": "BeginSeqNo",
    "type": "int",
    "description": "Message sequence number of first message in range to be resent"
  },
  {
    "tag": "8",
    "name": "BeginString",
    "type": "String",
    "description": "Identifies beginning of new message and protocol version. ALWAYS FIRST FIELD IN MESSAGE. (Always unencrypted)"
  },
  {
    "tag": "9",
    "name": "BodyLength",
    "type": "int",
    "description": "Message length, in bytes, forward to the CheckSum field. ALWAYS SECOND FIELD IN MESSAGE. (Always unencrypted)"
  },
  {
    "tag": "10",
    "name": "CheckSum",
    "type": "String",
    "description": "Three byte, simple checksum (see Appendix B: CheckSum Calculation for description). ALWAYS LAST FIELD IN MESSAGE; i.e. serves, with the trailing <SOH>, as the end-of-message delimiter. Always defined as three characters. (Always unencrypted)"
  },
  {
    "tag": "11",
    "name": "ClOrdID",
    "type": "String",
    "description": "Unique identifier for Order as assigned by institution (identified by SenderCompID or OnBehalfOfCompID as appropriate). Uniqueness must be guaranteed within a single trading day. Firms, particularly those which electronically submit multi-day orders, trade globally or throughout market close periods,should ensure uniqueness across days, for example by embedding a date within the ClOrdID field."
  },
  {
    "tag": "12",
    "name": "Commission",
    "type": "Amt",
    "description": "Commission. Note if CommType is percentage, Commission of 5% should be represented as .05."
  },
  {
    "tag": "13",
    "name": "CommType",
    "type": "char",
    "description": "Commission type",
    "enum": [
      {
        "value": "1",
        "symbolicName": "PerUnit",
        "description": "per share"
      },
      {
        "value": "2",
        "symbolicName": "Percent",
        "description": "percentage"
      },
      {
        "value": "3",
        "symbolicName": "Absolute",
        "description": "absolute"
      }
    ]
  },
  {
    "tag": "14",
    "name": "CumQty",
    "type": "Qty",
    "description": "Total number of shares filled.\n(Prior to FIX 4.2 this field was of type int)"
  },
  {
    "tag": "15",
    "name": "Currency",
    "type": "Currency",
    "description": "Identifies currency used for price. Absence of this field is interpreted as the default for the security. It is recommended that systems provide the currency value whenever possible. See Appendix A: Valid Currency Codes for information on obtaining valid values."
  },
  {
    "tag": "16",
    "name": "EndSeqNo",
    "type": "int",
    "description": "Message sequence number of last message in range to be resent. If request is for a single message BeginSeqNo = EndSeqNo. If request is for all messages subsequent to a particular message, EndSeqNo = \"0\" (representing infinity)."
  },
  {
    "tag": "17",
    "name": "ExecID",
    "type": "String",
    "description": "Unique identifier of execution message as assigned by broker (will be 0 (zero) for ExecTransType=3 (Status)).\nUniqueness must be guaranteed within a single trading day or the life of a multi-day order. Firms which accept multi-day orders should consider embedding a date within the ExecID field to assure uniqueness across days.\n(Prior to FIX 4.1 this field was of type int)"
  },
  {
    "tag": "18",
    "name": "ExecInst",
    "type": "MultipleValueString",
    "description": "Instructions for order handling on exchange trading floor. If more than one instruction is applicable to an order, this field can contain multiple instructions separated by space.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "StayOnOfferSide",
        "description": "Stay on offerside"
      },
      {
        "value": "1",
        "symbolicName": "NotHeld",
        "description": "Not held"
      },
      {
        "value": "2",
        "symbolicName": "Work",
        "description": "Work"
      },
      {
        "value": "3",
        "symbolicName": "GoAlong",
        "description": "Go along"
      },
      {
        "value": "4",
        "symbolicName": "OverTheDay",
        "description": "Over the day"
      },
      {
        "value": "5",
        "symbolicName": "Held",
        "description": "Held"
      },
      {
        "value": "6",
        "symbolicName": "ParticipateDoNotInitiate",
        "description": "Participate don't initiate"
      },
      {
        "value": "7",
        "symbolicName": "StrictScale",
        "description": "Strict scale"
      },
      {
        "value": "8",
        "symbolicName": "TryToScale",
        "description": "Try to scale"
      },
      {
        "value": "9",
        "symbolicName": "StayOnBidSide",
        "description": "Stay on bidside"
      },
      {
        "value": "A",
        "symbolicName": "NoCross",
        "description": "No cross (cross is forbidden)"
      },
      {
        "value": "B",
        "symbolicName": "OKToCross",
        "description": "OK to cross"
      },
      {
        "value": "C",
        "symbolicName": "CallFirst",
        "description": "Call first"
      },
      {
        "value": "D",
        "symbolicName": "PercentOfVolume",
        "description": "Percent of volume (indicates that the sender does not want to be all of the volume on the floor vs. a specific percentage)"
      },
      {
        "value": "E",
        "symbolicName": "DoNotIncrease",
        "description": "Do not increase - DNI"
      },
      {
        "value": "F",
        "symbolicName": "DoNotReduce",
        "description": "Do not reduce - DNR"
      },
      {
        "value": "G",
        "symbolicName": "AllOrNone",
        "description": "All or none - AON"
      },
      {
        "value": "I",
        "symbolicName": "InstitutionsOnly",
        "description": "Institutions only"
      },
      {
        "value": "L",
        "symbolicName": "LastPeg",
        "description": "Last peg (last sale)"
      },
      {
        "value": "M",
        "symbolicName": "MidPricePeg",
        "description": "Mid-price peg (midprice of inside quote)"
      },
      {
        "value": "N",
        "symbolicName": "NonNegotiable",
        "description": "Non-negotiable"
      },
      {
        "value": "O",
        "symbolicName": "OpeningPeg",
        "description": "Opening peg"
      },
      {
        "value": "P",
        "symbolicName": "MarketPeg",
        "description": "Market peg"
      },
      {
        "value": "R",
        "symbolicName": "PrimaryPeg",
        "description": "Primary peg (primary market - buy at bid/sell at offer)"
      },
      {
        "value": "S",
        "symbolicName": "Suspend",
        "description": "Suspend"
      },
      {
        "value": "T",
        "symbolicName": "FixedPegToLocalBestBidOrOfferAtTimeOfOrder",
        "description": "Fixed Peg to Local best bid or offer at time of order"
      },
      {
        "value": "U",
        "symbolicName": "CustomerDisplayInstruction",
        "description": "Customer Display Instruction (Rule11Ac1-1/4)"
      },
      {
        "value": "V",
        "symbolicName": "Netting",
        "description": "Netting (for Forex)"
      },
      {
        "value": "W",
        "symbolicName": "PegToVWAP",
        "description": "Peg to VWAP"
      }
    ]
  },
  {
    "tag": "19",
    "name": "ExecRefID",
    "type": "String",
    "description": "Reference identifier used with Cancel and Correct transaction types.\n(Prior to FIX 4.1 this field was of type int)"
  },
  {
    "tag": "20",
    "name": "ExecTransType",
    "type": "char",
    "description": "Identifies transaction type",
    "enum": [
      {
        "value": "0",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "1",
        "symbolicName": "Cancel",
        "description": "Cancel"
      },
      {
        "value": "2",
        "symbolicName": "Correct",
        "description": "Correct"
      },
      {
        "value": "3",
        "symbolicName": "Status",
        "description": "Status"
      }
    ]
  },
  {
    "tag": "21",
    "name": "HandlInst",
    "type": "char",
    "description": "Instructions for order handling on Broker trading floor",
    "enum": [
      {
        "value": "1",
        "symbolicName": "AutomatedExecutionNoIntervention",
        "description": "Automated execution order, private, no Broker intervention"
      },
      {
        "value": "2",
        "symbolicName": "AutomatedExecutionInterventionOK",
        "description": "Automated execution order, public, Broker intervention OK"
      },
      {
        "value": "3",
        "symbolicName": "ManualOrder",
        "description": "Manual order, best execution"
      }
    ]
  },
  {
    "tag": "22",
    "name": "IDSource",
    "type": "String",
    "description": "Identifies class of alternative SecurityID",
    "enum": [
      {
        "value": "1",
        "symbolicName": "CUSIP",
        "description": "CUSIP"
      },
      {
        "value": "2",
        "symbolicName": "SEDOL",
        "description": "SEDOL"
      },
      {
        "value": "3",
        "symbolicName": "QUIK",
        "description": "QUIK"
      },
      {
        "value": "4",
        "symbolicName": "ISINNumber",
        "description": "ISIN number"
      },
      {
        "value": "5",
        "symbolicName": "RICCode",
        "description": "RIC code"
      },
      {
        "value": "6",
        "symbolicName": "ISOCurrencyCode",
        "description": "ISO Currency Code"
      },
      {
        "value": "7",
        "symbolicName": "ISOCountryCode",
        "description": "ISO Country Code"
      },
      {
        "value": "8",
        "symbolicName": "ExchangeSymbol",
        "description": "Exchange Symbol"
      },
      {
        "value": "9",
        "symbolicName": "ConsolidatedTapeAssociation",
        "description": "Consolidated Tape Association (CTA) Symbol (SIAC CTS/CQS line format)"
      }
    ]
  },
  {
    "tag": "23",
    "name": "IOIid",
    "type": "String",
    "description": "Unique identifier of IOI message.\n(Prior to FIX 4.1 this field was of type int)"
  },
  {
    "tag": "24",
    "name": "IOIOthSvc",
    "type": "char",
    "description": ""
  },
  {
    "tag": "25",
    "name": "IOIQltyInd",
    "type": "char",
    "description": "Relative quality of indication",
    "enum": [
      {
        "value": "H",
        "symbolicName": "High",
        "description": "High"
      },
      {
        "value": "L",
        "symbolicName": "Low",
        "description": "Low"
      },
      {
        "value": "M",
        "symbolicName": "Medium",
        "description": "Medium"
      }
    ]
  },
  {
    "tag": "26",
    "name": "IOIRefID",
    "type": "String",
    "description": "Reference identifier used with CANCEL and REPLACE, transaction types.\n(Prior to FIX 4.1 this field was of type int)"
  },
  {
    "tag": "27",
    "name": "IOIShares",
    "type": "String",
    "description": "Number of shares in numeric or relative size.",
    "enum": [
      {
        "value": "L",
        "symbolicName": "Large",
        "description": "Large"
      },
      {
        "value": "M",
        "symbolicName": "Medium",
        "description": "Medium"
      },
      {
        "value": "S",
        "symbolicName": "Small",
        "description": "Small"
      }
    ]
  },
  {
    "tag": "28",
    "name": "IOITransType",
    "type": "char",
    "description": "Identifies IOI message transaction type",
    "enum": [
      {
        "value": "C",
        "symbolicName": "Cancel",
        "description": "Cancel"
      },
      {
        "value": "N",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "R",
        "symbolicName": "Replace",
        "description": "Replace"
      }
    ]
  },
  {
    "tag": "29",
    "name": "LastCapacity",
    "type": "char",
    "description": "Broker capacity in order execution",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Agent",
        "description": "Agent"
      },
      {
        "value": "2",
        "symbolicName": "CrossAsAgent",
        "description": "Cross as agent"
      },
      {
        "value": "3",
        "symbolicName": "CrossAsPrincipal",
        "description": "Cross as principal"
      },
      {
        "value": "4",
        "symbolicName": "Principal",
        "description": "Principal"
      }
    ]
  },
  {
    "tag": "30",
    "name": "LastMkt",
    "type": "Exchange",
    "description": "Market of execution for last fill"
  },
  {
    "tag": "31",
    "name": "LastPx",
    "type": "Price",
    "description": "Price of this (last) fill. Field not required for ExecTransType = 3 (Status)"
  },
  {
    "tag": "32",
    "name": "LastShares",
    "type": "Qty",
    "description": "Quantity of shares bought/sold on this (last) fill. Field not required for ExecTransType = 3 (Status)\n(Prior to FIX 4.2 this field was of type int)"
  },
  {
    "tag": "33",
    "name": "LinesOfText",
    "type": "int",
    "description": "Identifies number of lines of text body"
  },
  {
    "tag": "34",
    "name": "MsgSeqNum",
    "type": "int",
    "description": "Integer message sequence number."
  },
  {
    "tag": "35",
    "name": "MsgType",
    "type": "String",
    "description": "Defines message type. ALWAYS THIRD FIELD IN MESSAGE. (Always unencrypted)\nNote: A \"U\" as the first character in the MsgType field (i.e. U1, U2, etc) indicates that the message format is privately defined between the sender and receiver.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Heartbeat",
        "description": "Heartbeat"
      },
      {
        "value": "1",
        "symbolicName": "TestRequest",
        "description": "Test Request"
      },
      {
        "value": "2",
        "symbolicName": "ResendRequest",
        "description": "Resend Request"
      },
      {
        "value": "3",
        "symbolicName": "Reject",
        "description": "Reject"
      },
      {
        "value": "4",
        "symbolicName": "SequenceReset",
        "description": "Sequence Reset"
      },
      {
        "value": "5",
        "symbolicName": "Logout",
        "description": "Logout"
      },
      {
        "value": "6",
        "symbolicName": "IOI",
        "description": "Indication of Interest"
      },
      {
        "value": "7",
        "symbolicName": "Advertisement",
        "description": "Advertisement"
      },
      {
        "value": "8",
        "symbolicName": "ExecutionReport",
        "description": "Execution Report"
      },
      {
        "value": "9",
        "symbolicName": "OrderCancelReject",
        "description": "Order Cancel Reject"
      },
      {
        "value": "a",
        "symbolicName": "QuoteStatusRequest",
        "description": "Quote Status Request"
      },
      {
        "value": "A",
        "symbolicName": "Logon",
        "description": "Logon"
      },
      {
        "value": "B",
        "symbolicName": "News",
        "description": "News"
      },
      {
        "value": "b",
        "symbolicName": "MassQuoteAcknowledgement",
        "description": "Quote Acknowledgement"
      },
      {
        "value": "C",
        "symbolicName": "Email",
        "description": "Email"
      },
      {
        "value": "c",
        "symbolicName": "SecurityDefinitionRequest",
        "description": "Security Definition Request"
      },
      {
        "value": "D",
        "symbolicName": "NewOrderSingle",
        "description": "Order Single"
      },
      {
        "value": "d",
        "symbolicName": "SecurityDefinition",
        "description": "Security Definition"
      },
      {
        "value": "E",
        "symbolicName": "NewOrderList",
        "description": "Order List"
      },
      {
        "value": "e",
        "symbolicName": "SecurityStatusRequest",
        "description": "Security Status Request"
      },
      {
        "value": "f",
        "symbolicName": "SecurityStatus",
        "description": "Security Status"
      },
      {
        "value": "F",
        "symbolicName": "OrderCancelRequest",
        "description": "Order Cancel Request"
      },
      {
        "value": "G",
        "symbolicName": "OrderCancelReplaceRequest",
        "description": "Order Cancel/Replace Request"
      },
      {
        "value": "g",
        "symbolicName": "TradingSessionStatusRequest",
        "description": "Trading Session Status Request"
      },
      {
        "value": "H",
        "symbolicName": "OrderStatusRequest",
        "description": "Order Status Request"
      },
      {
        "value": "h",
        "symbolicName": "TradingSessionStatus",
        "description": "Trading Session Status"
      },
      {
        "value": "i",
        "symbolicName": "MassQuote",
        "description": "Mass Quote"
      },
      {
        "value": "j",
        "symbolicName": "BusinessMessageReject",
        "description": "Business Message Reject"
      },
      {
        "value": "J",
        "symbolicName": "AllocationInstruction",
        "description": "Allocation"
      },
      {
        "value": "K",
        "symbolicName": "ListCancelRequest",
        "description": "List Cancel Request"
      },
      {
        "value": "k",
        "symbolicName": "BidRequest",
        "description": "Bid Request"
      },
      {
        "value": "l",
        "symbolicName": "BidResponse",
        "description": "Bid Response (lowercase L)"
      },
      {
        "value": "L",
        "symbolicName": "ListExecute",
        "description": "List Execute"
      },
      {
        "value": "m",
        "symbolicName": "ListStrikePrice",
        "description": "List Strike Price"
      },
      {
        "value": "M",
        "symbolicName": "ListStatusRequest",
        "description": "List Status Request"
      },
      {
        "value": "N",
        "symbolicName": "ListStatus",
        "description": "List Status"
      },
      {
        "value": "P",
        "symbolicName": "AllocationInstructionAck",
        "description": "Allocation ACK"
      },
      {
        "value": "Q",
        "symbolicName": "DontKnowTrade",
        "description": "Dont Know Trade (DK)"
      },
      {
        "value": "R",
        "symbolicName": "QuoteRequest",
        "description": "Quote Request"
      },
      {
        "value": "S",
        "symbolicName": "Quote",
        "description": "Quote"
      },
      {
        "value": "T",
        "symbolicName": "SettlementInstructions",
        "description": "Settlement Instructions"
      },
      {
        "value": "V",
        "symbolicName": "MarketDataRequest",
        "description": "Market Data Request"
      },
      {
        "value": "W",
        "symbolicName": "MarketDataSnapshotFullRefresh",
        "description": "Market Data-Snapshot/Full Refresh"
      },
      {
        "value": "X",
        "symbolicName": "MarketDataIncrementalRefresh",
        "description": "Market Data-Incremental Refresh"
      },
      {
        "value": "Y",
        "symbolicName": "MarketDataRequestReject",
        "description": "Market Data Request Reject"
      },
      {
        "value": "Z",
        "symbolicName": "QuoteCancel",
        "description": "Quote Cancel"
      }
    ]
  },
  {
    "tag": "36",
    "name": "NewSeqNo",
    "type": "int",
    "description": "New sequence number"
  },
  {
    "tag": "37",
    "name": "OrderID",
    "type": "String",
    "description": "Unique identifier for Order as assigned by broker. Uniqueness must be guaranteed within a single trading day. Firms which accept multi-day orders should consider embedding a date within the OrderID field to assure uniqueness across days."
  },
  {
    "tag": "38",
    "name": "OrderQty",
    "type": "Qty",
    "description": "Number of shares ordered. This represents the number of shares for equities or based on normal convention the number of contracts for options, futures, convertible bonds, etc.\n(Prior to FIX 4.2 this field was of type int)"
  },
  {
    "tag": "39",
    "name": "OrdStatus",
    "type": "char",
    "description": "Identifies current status of order.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "1",
        "symbolicName": "PartiallyFilled",
        "description": "Partially filled"
      },
      {
        "value": "2",
        "symbolicName": "Filled",
        "description": "Filled"
      },
      {
        "value": "3",
        "symbolicName": "DoneForDay",
        "description": "Done for day"
      },
      {
        "value": "4",
        "symbolicName": "Canceled",
        "description": "Canceled"
      },
      {
        "value": "5",
        "symbolicName": "Replaced",
        "description": "Replaced"
      },
      {
        "value": "6",
        "symbolicName": "PendingCancel",
        "description": "Pending Cancel (e.g. result of Order Cancel Request)"
      },
      {
        "value": "7",
        "symbolicName": "Stopped",
        "description": "Stopped"
      },
      {
        "value": "8",
        "symbolicName": "Rejected",
        "description": "Rejected"
      },
      {
        "value": "9",
        "symbolicName": "Suspended",
        "description": "Suspended"
      },
      {
        "value": "A",
        "symbolicName": "PendingNew",
        "description": "Pending New"
      },
      {
        "value": "B",
        "symbolicName": "Calculated",
        "description": "Calculated"
      },
      {
        "value": "C",
        "symbolicName": "Expired",
        "description": "Expired"
      },
      {
        "value": "D",
        "symbolicName": "AcceptedForBidding",
        "description": "Accepted for bidding"
      },
      {
        "value": "E",
        "symbolicName": "PendingReplace",
        "description": "Pending Replace (e.g. result of Order Cancel/Replace Request)"
      }
    ]
  },
  {
    "tag": "40",
    "name": "OrdType",
    "type": "char",
    "description": "Order type.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Market",
        "description": "Market"
      },
      {
        "value": "2",
        "symbolicName": "Limit",
        "description": "Limit"
      },
      {
        "value": "3",
        "symbolicName": "Stop",
        "description": "Stop"
      },
      {
        "value": "4",
        "symbolicName": "StopLimit",
        "description": "Stop limit"
      },
      {
        "value": "5",
        "symbolicName": "MarketOnClose",
        "description": "Market on close"
      },
      {
        "value": "6",
        "symbolicName": "WithOrWithout",
        "description": "With or without"
      },
      {
        "value": "7",
        "symbolicName": "LimitOrBetter",
        "description": "Limit or better"
      },
      {
        "value": "8",
        "symbolicName": "LimitWithOrWithout",
        "description": "Limit with or without"
      },
      {
        "value": "9",
        "symbolicName": "OnBasis",
        "description": "On basis"
      },
      {
        "value": "A",
        "symbolicName": "OnClose",
        "description": "On close"
      },
      {
        "value": "B",
        "symbolicName": "LimitOnClose",
        "description": "Limit on close"
      },
      {
        "value": "C",
        "symbolicName": "ForexMarket",
        "description": "Forex - Market"
      },
      {
        "value": "D",
        "symbolicName": "PreviouslyQuoted",
        "description": "Previously quoted"
      },
      {
        "value": "E",
        "symbolicName": "PreviouslyIndicated",
        "description": "Previously indicated"
      },
      {
        "value": "F",
        "symbolicName": "ForexLimit",
        "description": "Forex - Limit"
      },
      {
        "value": "G",
        "symbolicName": "ForexSwap",
        "description": "Forex - Swap"
      },
      {
        "value": "H",
        "symbolicName": "ForexPreviouslyQuoted",
        "description": "Forex - Previously Quoted"
      },
      {
        "value": "I",
        "symbolicName": "Funari",
        "description": "Funari (Limit Day Order with unexecuted portion handled as Market On Close. e.g. Japan)"
      },
      {
        "value": "P",
        "symbolicName": "Pegged",
        "description": "Pegged"
      }
    ]
  },
  {
    "tag": "41",
    "name": "OrigClOrdID",
    "type": "String",
    "description": "ClOrdID of the previous order (NOT the initial order of the day) as assigned by the institution, used to identify the previous order in cancel and cancel/replace requests."
  },
  {
    "tag": "42",
    "name": "OrigTime",
    "type": "UTCTimestamp",
    "description": "Time of message origination (always expressed in UTC (Universal Time Coordinated, also known as \"GMT\"))"
  },
  {
    "tag": "43",
    "name": "PossDupFlag",
    "type": "Boolean",
    "description": "Indicates possible retransmission of message with this sequence number",
    "enum": [
      {
        "value": "N",
        "symbolicName": "OriginalTransmission",
        "description": "Original transmission"
      },
      {
        "value": "Y",
        "symbolicName": "PossibleDuplicate",
        "description": "Possible duplicate"
      }
    ]
  },
  {
    "tag": "44",
    "name": "Price",
    "type": "Price",
    "description": "Price per share"
  },
  {
    "tag": "45",
    "name": "RefSeqNum",
    "type": "int",
    "description": "Reference message sequence number"
  },
  {
    "tag": "46",
    "name": "RelatdSym",
    "type": "String",
    "description": "Symbol of issue related to story. Can be repeated within message to identify multiple companies."
  },
  {
    "tag": "47",
    "name": "Rule80A",
    "type": "char",
    "description": "Note that the name of this field is changing to \"OrderCapacity\" as Rule80A is a very US market-specific term. Other world markets need to convey similar information, however, often a subset of the US values. . See the \"Rule80A (aka OrderCapacity) Usage by Market\" appendix for market-specific usage of this field.",
    "enum": [
      {
        "value": "A",
        "symbolicName": "AgencySingleOrder",
        "description": "Agency single order"
      },
      {
        "value": "B",
        "symbolicName": "ShortExemptTransactionAType",
        "description": "Short exempt transaction (refer to A type)"
      },
      {
        "value": "C",
        "symbolicName": "ProprietaryNonAlgo",
        "description": "Program Order, non-index arb, for Member firm/org"
      },
      {
        "value": "D",
        "symbolicName": "ProgramOrderMember",
        "description": "Program Order, index arb, for Member firm/org"
      },
      {
        "value": "E",
        "symbolicName": "ShortExemptTransactionForPrincipal",
        "description": "Registered Equity Market Maker trades"
      },
      {
        "value": "F",
        "symbolicName": "ShortExemptTransactionWType",
        "description": "Short exempt transaction (refer to W type)"
      },
      {
        "value": "H",
        "symbolicName": "ShortExemptTransactionIType",
        "description": "Short exempt transaction (refer to I type)"
      },
      {
        "value": "I",
        "symbolicName": "IndividualInvestor",
        "description": "Individual Investor, single order"
      },
      {
        "value": "J",
        "symbolicName": "ProprietaryAlgo",
        "description": "Program Order, index arb, for individual customer"
      },
      {
        "value": "K",
        "symbolicName": "AgencyAlgo",
        "description": "Program Order, non-index arb, for individual customer"
      },
      {
        "value": "L",
        "symbolicName": "ShortExemptTransactionMemberAffliated",
        "description": "Short exempt transaction for member competing market-maker affiliated with the firm clearing the trade (refer to P and O types)"
      },
      {
        "value": "M",
        "symbolicName": "ProgramOrderOtherMember",
        "description": "Program Order, index arb, for other member"
      },
      {
        "value": "N",
        "symbolicName": "AgentForOtherMember",
        "description": "Program Order, non-index arb, for other member"
      },
      {
        "value": "O",
        "symbolicName": "ProprietaryTransactionAffiliated",
        "description": "Competing dealer trades"
      },
      {
        "value": "P",
        "symbolicName": "Principal",
        "description": "Principal"
      },
      {
        "value": "R",
        "symbolicName": "TransactionNonMember",
        "description": "Competing dealer trades"
      },
      {
        "value": "S",
        "symbolicName": "SpecialistTrades",
        "description": "Specialist trades"
      },
      {
        "value": "T",
        "symbolicName": "TransactionUnaffiliatedMember",
        "description": "Competing dealer trades"
      },
      {
        "value": "U",
        "symbolicName": "AgencyIndexArb",
        "description": "Program Order, index arb, for other agency"
      },
      {
        "value": "W",
        "symbolicName": "AllOtherOrdersAsAgentForOtherMember",
        "description": "All other orders as agent for other member"
      },
      {
        "value": "X",
        "symbolicName": "ShortExemptTransactionMemberNotAffliated",
        "description": "Short exempt transaction for member competing market-maker not affiliated with the firm clearing the trade (refer to W and T types)"
      },
      {
        "value": "Y",
        "symbolicName": "AgencyNonAlgo",
        "description": "Program Order, non-index arb, for other agency"
      },
      {
        "value": "Z",
        "symbolicName": "ShortExemptTransactionNonMember",
        "description": "Short exempt transaction for non-member competing market-maker (refer to A and R types)"
      }
    ]
  },
  {
    "tag": "48",
    "name": "SecurityID",
    "type": "String",
    "description": "CUSIP or other alternate security identifier"
  },
  {
    "tag": "49",
    "name": "SenderCompID",
    "type": "String",
    "description": "Assigned value used to identify firm sending message."
  },
  {
    "tag": "50",
    "name": "SenderSubID",
    "type": "String",
    "description": "Assigned value used to identify specific message originator (desk, trader, etc.)"
  },
  {
    "tag": "51",
    "name": "SendingDate",
    "type": "LocalMktDate",
    "description": "No longer used. Included here for reference to prior versions."
  },
  {
    "tag": "52",
    "name": "SendingTime",
    "type": "UTCTimestamp",
    "description": "Time of message transmission (always expressed in UTC (Universal Time Coordinated, also known as \"GMT\")"
  },
  {
    "tag": "53",
    "name": "Shares",
    "type": "Qty",
    "description": "Number of shares\n(Prior to FIX 4.2 this field was of type int)"
  },
  {
    "tag": "54",
    "name": "Side",
    "type": "char",
    "description": "Side of order",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Buy",
        "description": "Buy"
      },
      {
        "value": "2",
        "symbolicName": "Sell",
        "description": "Sell"
      },
      {
        "value": "3",
        "symbolicName": "BuyMinus",
        "description": "Buy minus"
      },
      {
        "value": "4",
        "symbolicName": "SellPlus",
        "description": "Sell plus"
      },
      {
        "value": "5",
        "symbolicName": "SellShort",
        "description": "Sell short"
      },
      {
        "value": "6",
        "symbolicName": "SellShortExempt",
        "description": "Sell short exempt"
      },
      {
        "value": "7",
        "symbolicName": "Undisclosed",
        "description": "Undisclosed (valid for IOI and List Order messages only)"
      },
      {
        "value": "8",
        "symbolicName": "Cross",
        "description": "Cross (orders where counterparty is an exchange, valid for all messages except IOIs)"
      },
      {
        "value": "9",
        "symbolicName": "CrossShort",
        "description": "Cross short"
      }
    ]
  },
  {
    "tag": "55",
    "name": "Symbol",
    "type": "String",
    "description": "Ticker symbol"
  },
  {
    "tag": "56",
    "name": "TargetCompID",
    "type": "String",
    "description": "Assigned value used to identify receiving firm."
  },
  {
    "tag": "57",
    "name": "TargetSubID",
    "type": "String",
    "description": "Assigned value used to identify specific individual or unit intended to receive message. \"ADMIN\" reserved for administrative messages not intended for a specific user."
  },
  {
    "tag": "58",
    "name": "Text",
    "type": "String",
    "description": "Free format text string\n(Note: this field does not have a specified maximum length)"
  },
  {
    "tag": "59",
    "name": "TimeInForce",
    "type": "char",
    "description": "Specifies how long the order remains in effect. Absence of this field is interpreted as DAY.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Day",
        "description": "Day"
      },
      {
        "value": "1",
        "symbolicName": "GoodTillCancel",
        "description": "Good Till Cancel (GTC)"
      },
      {
        "value": "2",
        "symbolicName": "AtTheOpening",
        "description": "At the Opening (OPG)"
      },
      {
        "value": "3",
        "symbolicName": "ImmediateOrCancel",
        "description": "Immediate or Cancel (IOC)"
      },
      {
        "value": "4",
        "symbolicName": "FillOrKill",
        "description": "Fill or Kill (FOK)"
      },
      {
        "value": "5",
        "symbolicName": "GoodTillCrossing",
        "description": "Good Till Crossing (GTX)"
      },
      {
        "value": "6",
        "symbolicName": "GoodTillDate",
        "description": "Good Till Date"
      }
    ]
  },
  {
    "tag": "60",
    "name": "TransactTime",
    "type": "UTCTimestamp",
    "description": "Time of execution/order creation (expressed in UTC (Universal Time Coordinated, also known as \"GMT\")"
  },
  {
    "tag": "61",
    "name": "Urgency",
    "type": "char",
    "description": "Urgency flag",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Normal",
        "description": "Normal"
      },
      {
        "value": "1",
        "symbolicName": "Flash",
        "description": "Flash"
      },
      {
        "value": "2",
        "symbolicName": "Background",
        "description": "Background"
      }
    ]
  },
  {
    "tag": "62",
    "name": "ValidUntilTime",
    "type": "UTCTimestamp",
    "description": "Indicates expiration time of indication message (always expressed in UTC (Universal Time Coordinated, also known as \"GMT\")"
  },
  {
    "tag": "63",
    "name": "SettlmntTyp",
    "type": "char",
    "description": "Indicates order settlement period. Absence of this field is interpreted as Regular. Regular is defined as the default settlement period for the particular security on the exchange of execution.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Regular",
        "description": "Regular"
      },
      {
        "value": "1",
        "symbolicName": "Cash",
        "description": "Cash"
      },
      {
        "value": "2",
        "symbolicName": "NextDay",
        "description": "Next Day"
      },
      {
        "value": "3",
        "symbolicName": "TPlus2",
        "description": "T+2"
      },
      {
        "value": "4",
        "symbolicName": "TPlus3",
        "description": "T+3"
      },
      {
        "value": "5",
        "symbolicName": "TPlus4",
        "description": "T+4"
      },
      {
        "value": "6",
        "symbolicName": "Future",
        "description": "Future"
      },
      {
        "value": "7",
        "symbolicName": "WhenAndIfIssued",
        "description": "When Issued"
      },
      {
        "value": "8",
        "symbolicName": "SellersOption",
        "description": "Sellers Option"
      },
      {
        "value": "9",
        "symbolicName": "TPlus5",
        "description": "T+ 5"
      }
    ]
  },
  {
    "tag": "64",
    "name": "FutSettDate",
    "type": "LocalMktDate",
    "description": "Specific date of trade settlement (SettlementDate) in YYYYMMDD format. Required when SettlmntTyp = 6 (Future) or SettlmntTyp = 8 (Sellers Option). (expressed in local time at place of settlement)"
  },
  {
    "tag": "65",
    "name": "SymbolSfx",
    "type": "String",
    "description": "Additional information about the security (e.g. preferred, warrants, etc.). Note also see SecurityType.\nValid values:\nAs defined in the NYSE Stock and bond Symbol Directory and in the AMEX Fitch Directory"
  },
  {
    "tag": "66",
    "name": "ListID",
    "type": "String",
    "description": "Unique identifier for list as assigned by institution, used to associate multiple individual orders. Uniqueness must be guaranteed within a single trading day. Firms which generate multi-day orders should consider embedding a date within the ListID field to assure uniqueness across days."
  },
  {
    "tag": "67",
    "name": "ListSeqNo",
    "type": "int",
    "description": "Sequence of individual order within list (i.e. ListSeqNo of ListNoOrds, 2 of 25, 3 of 25, . . . )"
  },
  {
    "tag": "68",
    "name": "TotNoOrders",
    "type": "int",
    "description": "Total number of list order entries across all messages. Should be the sum of all NoOrders in each message that has repeating list order entries related to the same ListID. Used to support fragmentation.\n(Prior to FIX 4.2 this field was named \"ListNoOrds\")"
  },
  {
    "tag": "69",
    "name": "ListExecInst",
    "type": "String",
    "description": "Free format text message containing list handling and execution instructions."
  },
  {
    "tag": "70",
    "name": "AllocID",
    "type": "String",
    "description": "Unique identifier for allocation message.\n(Prior to FIX 4.1 this field was of type int)"
  },
  {
    "tag": "71",
    "name": "AllocTransType",
    "type": "char",
    "description": "Identifies allocation transaction type",
    "enum": [
      {
        "value": "0",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "1",
        "symbolicName": "Replace",
        "description": "Replace"
      },
      {
        "value": "2",
        "symbolicName": "Cancel",
        "description": "Cancel"
      },
      {
        "value": "3",
        "symbolicName": "Preliminary",
        "description": "Preliminary (without MiscFees and NetMoney)"
      },
      {
        "value": "4",
        "symbolicName": "Calculated",
        "description": "Calculated (includes MiscFees and NetMoney)"
      },
      {
        "value": "5",
        "symbolicName": "CalculatedWithoutPreliminary",
        "description": "Calculated without Preliminary (sent unsolicited by broker, includes MiscFees and NetMoney)"
      }
    ]
  },
  {
    "tag": "72",
    "name": "RefAllocID",
    "type": "String",
    "description": "Reference identifier to be used with Replace, Cancel, and Calculated AllocTransType messages.\n(Prior to FIX 4.1 this field was of type int)"
  },
  {
    "tag": "73",
    "name": "NoOrders",
    "type": "int",
    "description": "Indicates number of orders to be combined for average pricing and allocation."
  },
  {
    "tag": "74",
    "name": "AvgPrxPrecision",
    "type": "int",
    "description": "Indicates number of decimal places to be used for average pricing. Absence of this field indicates that default precision arranged by the broker/institution is to be used."
  },
  {
    "tag": "75",
    "name": "TradeDate",
    "type": "LocalMktDate",
    "description": "Indicates date of trade referenced in this message in YYYYMMDD format. Absence of this field indicates current day (expressed in local time at place of trade)."
  },
  {
    "tag": "76",
    "name": "ExecBroker",
    "type": "String",
    "description": "Identifies executing / give-up broker. Standard NASD market-maker mnemonic is preferred."
  },
  {
    "tag": "77",
    "name": "OpenClose",
    "type": "char",
    "description": "Indicates whether the resulting position after a trade should be an opening position or closing position. Used for omnibus accounting - where accounts are held on a gross basis instead of being netted together.",
    "enum": [
      {
        "value": "C",
        "symbolicName": "Close",
        "description": "Close"
      },
      {
        "value": "O",
        "symbolicName": "Open",
        "description": "Open"
      }
    ]
  },
  {
    "tag": "78",
    "name": "NoAllocs",
    "type": "int",
    "description": "Number of repeating AllocAccount/AllocPrice entries."
  },
  {
    "tag": "79",
    "name": "AllocAccount",
    "type": "String",
    "description": "Sub-account mnemonic"
  },
  {
    "tag": "80",
    "name": "AllocShares",
    "type": "Qty",
    "description": "Number of shares to be allocated to specific sub-account\n(Prior to FIX 4.2 this field was of type int)"
  },
  {
    "tag": "81",
    "name": "ProcessCode",
    "type": "char",
    "description": "Processing code for sub-account. Absence of this field in AllocAccount / AllocPrice/AllocShares / ProcessCode instance indicates regular trade.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Regular",
        "description": "regular"
      },
      {
        "value": "1",
        "symbolicName": "SoftDollar",
        "description": "soft dollar"
      },
      {
        "value": "2",
        "symbolicName": "StepIn",
        "description": "step-in"
      },
      {
        "value": "3",
        "symbolicName": "StepOut",
        "description": "step-out"
      },
      {
        "value": "4",
        "symbolicName": "SoftDollarStepIn",
        "description": "soft-dollar step-in"
      },
      {
        "value": "5",
        "symbolicName": "SoftDollarStepOut",
        "description": "soft-dollar step-out"
      },
      {
        "value": "6",
        "symbolicName": "PlanSponsor",
        "description": "plan sponsor"
      }
    ]
  },
  {
    "tag": "82",
    "name": "NoRpts",
    "type": "int",
    "description": "Total number of reports within series."
  },
  {
    "tag": "83",
    "name": "RptSeq",
    "type": "int",
    "description": "Sequence number of message within report series."
  },
  {
    "tag": "84",
    "name": "CxlQty",
    "type": "Qty",
    "description": "Total number of shares canceled for this order.\n(Prior to FIX 4.2 this field was of type int)"
  },
  {
    "tag": "85",
    "name": "NoDlvyInst",
    "type": "int",
    "description": "Number of delivery instruction fields to follow\nNo longer used. Included here for reference to prior versions."
  },
  {
    "tag": "86",
    "name": "DlvyInst",
    "type": "String",
    "description": "Free format text field to indicate delivery instructions\nNo longer used. Included here for reference to prior versions."
  },
  {
    "tag": "87",
    "name": "AllocStatus",
    "type": "int",
    "description": "Identifies status of allocation.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Accepted",
        "description": "accepted (successfully processed)"
      },
      {
        "value": "1",
        "symbolicName": "BlockLevelReject",
        "description": "rejected"
      },
      {
        "value": "2",
        "symbolicName": "AccountLevelReject",
        "description": "partial accept"
      },
      {
        "value": "3",
        "symbolicName": "Received",
        "description": "received (received, not yet processed)"
      }
    ]
  },
  {
    "tag": "88",
    "name": "AllocRejCode",
    "type": "int",
    "description": "Identifies reason for rejection.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "UnknownAccount",
        "description": "unknown account(s)"
      },
      {
        "value": "1",
        "symbolicName": "IncorrectQuantity",
        "description": "incorrect quantity"
      },
      {
        "value": "2",
        "symbolicName": "IncorrectAveragegPrice",
        "description": "incorrect average price"
      },
      {
        "value": "3",
        "symbolicName": "UnknownExecutingBrokerMnemonic",
        "description": "unknown executing broker mnemonic"
      },
      {
        "value": "4",
        "symbolicName": "CommissionDifference",
        "description": "commission difference"
      },
      {
        "value": "5",
        "symbolicName": "UnknownOrderID",
        "description": "unknown OrderID"
      },
      {
        "value": "6",
        "symbolicName": "UnknownListID",
        "description": "unknown ListID"
      },
      {
        "value": "7",
        "symbolicName": "OtherSeeText",
        "description": "other"
      }
    ]
  },
  {
    "tag": "89",
    "name": "Signature",
    "type": "data",
    "description": "Electronic signature"
  },
  {
    "tag": "90",
    "name": "SecureDataLen",
    "type": "Length",
    "description": "Length of encrypted message"
  },
  {
    "tag": "91",
    "name": "SecureData",
    "type": "data",
    "description": "Actual encrypted data stream"
  },
  {
    "tag": "92",
    "name": "BrokerOfCredit",
    "type": "String",
    "description": "Broker to receive trade credit."
  },
  {
    "tag": "93",
    "name": "SignatureLength",
    "type": "Length",
    "description": "Number of bytes in signature field."
  },
  {
    "tag": "94",
    "name": "EmailType",
    "type": "char",
    "description": "Email message type.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "1",
        "symbolicName": "Reply",
        "description": "Reply"
      },
      {
        "value": "2",
        "symbolicName": "AdminReply",
        "description": "Admin Reply"
      }
    ]
  },
  {
    "tag": "95",
    "name": "RawDataLength",
    "type": "Length",
    "description": "Number of bytes in raw data field."
  },
  {
    "tag": "96",
    "name": "RawData",
    "type": "data",
    "description": "Unformatted raw data, can include bitmaps, word processor documents, etc."
  },
  {
    "tag": "97",
    "name": "PossResend",
    "type": "Boolean",
    "description": "Indicates that message may contain information that has been sent under another sequence number.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "OriginalTransmission",
        "description": "Original transmission"
      },
      {
        "value": "Y",
        "symbolicName": "PossibleResend",
        "description": "Possible resend"
      }
    ]
  },
  {
    "tag": "98",
    "name": "EncryptMethod",
    "type": "int",
    "description": "Method of encryption.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "None",
        "description": "None / other"
      },
      {
        "value": "1",
        "symbolicName": "PKCS",
        "description": "PKCS (proprietary)"
      },
      {
        "value": "2",
        "symbolicName": "DES",
        "description": "DES (ECB mode)"
      },
      {
        "value": "3",
        "symbolicName": "PKCSDES",
        "description": "PKCS/DES (proprietary)"
      },
      {
        "value": "4",
        "symbolicName": "PGPDES",
        "description": "PGP/DES (defunct)"
      },
      {
        "value": "5",
        "symbolicName": "PGPDESMD5",
        "description": "PGP/DES-MD5 (see app note on FIX web site)"
      },
      {
        "value": "6",
        "symbolicName": "PEM",
        "description": "PEM/DES-MD5 (see app note on FIX web site)"
      }
    ]
  },
  {
    "tag": "99",
    "name": "StopPx",
    "type": "Price",
    "description": "Price per share"
  },
  {
    "tag": "100",
    "name": "ExDestination",
    "type": "Exchange",
    "description": "Execution destination as defined by institution when order is entered.\nValid values:\nSee Appendix C"
  },
  {
    "tag": "102",
    "name": "CxlRejReason",
    "type": "int",
    "description": "Code to identify reason for cancel rejection.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "TooLateToCancel",
        "description": "Too late to cancel"
      },
      {
        "value": "1",
        "symbolicName": "UnknownOrder",
        "description": "Unknown order"
      },
      {
        "value": "2",
        "symbolicName": "BrokerCredit",
        "description": "Broker Option"
      },
      {
        "value": "3",
        "symbolicName": "OrderAlreadyInPendingStatus",
        "description": "Order already in Pending Cancel or Pending Replace status"
      }
    ]
  },
  {
    "tag": "103",
    "name": "OrdRejReason",
    "type": "int",
    "description": "Code to identify reason for order rejection.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "BrokerCredit",
        "description": "Broker option"
      },
      {
        "value": "1",
        "symbolicName": "UnknownSymbol",
        "description": "Unknown symbol"
      },
      {
        "value": "2",
        "symbolicName": "ExchangeClosed",
        "description": "Exchange closed"
      },
      {
        "value": "3",
        "symbolicName": "OrderExceedsLimit",
        "description": "Order exceeds limit"
      },
      {
        "value": "4",
        "symbolicName": "TooLateToEnter",
        "description": "Too late to enter"
      },
      {
        "value": "5",
        "symbolicName": "UnknownOrder",
        "description": "Unknown Order"
      },
      {
        "value": "6",
        "symbolicName": "DuplicateOrder",
        "description": "Duplicate Order (e.g. dupe ClOrdID)"
      },
      {
        "value": "7",
        "symbolicName": "DuplicateOfAVerballyCommunicatedOrder",
        "description": "Duplicate of a verbally communicated order"
      },
      {
        "value": "8",
        "symbolicName": "StaleOrder",
        "description": "Stale Order"
      }
    ]
  },
  {
    "tag": "104",
    "name": "IOIQualifier",
    "type": "char",
    "description": "Code to qualify IOI use.",
    "enum": [
      {
        "value": "A",
        "symbolicName": "AllOrNone",
        "description": "All or none"
      },
      {
        "value": "C",
        "symbolicName": "AtTheClose",
        "description": "At the close"
      },
      {
        "value": "I",
        "symbolicName": "InTouchWith",
        "description": "In touch with"
      },
      {
        "value": "L",
        "symbolicName": "Limit",
        "description": "Limit"
      },
      {
        "value": "M",
        "symbolicName": "MoreBehind",
        "description": "More behind"
      },
      {
        "value": "O",
        "symbolicName": "AtTheOpen",
        "description": "At the open"
      },
      {
        "value": "P",
        "symbolicName": "TakingAPosition",
        "description": "Taking a position"
      },
      {
        "value": "Q",
        "symbolicName": "AtTheMarket",
        "description": "At the Market (previously called Current Quote)"
      },
      {
        "value": "R",
        "symbolicName": "ReadyToTrade",
        "description": "Ready to trade"
      },
      {
        "value": "S",
        "symbolicName": "PortfolioShown",
        "description": "Portfolio show-n"
      },
      {
        "value": "T",
        "symbolicName": "ThroughTheDay",
        "description": "Through the day"
      },
      {
        "value": "V",
        "symbolicName": "Versus",
        "description": "Versus"
      },
      {
        "value": "W",
        "symbolicName": "Indication",
        "description": "Indication - Working away"
      },
      {
        "value": "X",
        "symbolicName": "CrossingOpportunity",
        "description": "Crossing opportunity"
      },
      {
        "value": "Y",
        "symbolicName": "AtTheMidpoint",
        "description": "At the Midpoint"
      },
      {
        "value": "Z",
        "symbolicName": "PreOpen",
        "description": "Pre-open"
      }
    ]
  },
  {
    "tag": "105",
    "name": "WaveNo",
    "type": "String",
    "description": "Identifier to aid in the management of multiple lists derived from a single, master list."
  },
  {
    "tag": "106",
    "name": "Issuer",
    "type": "String",
    "description": "Company name of security issuer (e.g. International Business Machines)"
  },
  {
    "tag": "107",
    "name": "SecurityDesc",
    "type": "String",
    "description": "Security description."
  },
  {
    "tag": "108",
    "name": "HeartBtInt",
    "type": "int",
    "description": "Heartbeat interval (seconds)"
  },
  {
    "tag": "109",
    "name": "ClientID",
    "type": "String",
    "description": "Firm identifier used in third party-transactions (should not be a substitute for OnBehalfOfCompID/DeliverToCompID)."
  },
  {
    "tag": "110",
    "name": "MinQty",
    "type": "Qty",
    "description": "Minimum quantity of an order to be executed.\n(Prior to FIX 4.2 this field was of type int)"
  },
  {
    "tag": "111",
    "name": "MaxFloor",
    "type": "Qty",
    "description": "Maximum number of shares within an order to be shown on the exchange floor at any given time.\n(Prior to FIX 4.2 this field was of type int)"
  },
  {
    "tag": "112",
    "name": "TestReqID",
    "type": "String",
    "description": "Identifier included in Test Request message to be returned in resulting Heartbeat"
  },
  {
    "tag": "113",
    "name": "ReportToExch",
    "type": "Boolean",
    "description": "Identifies party of trade responsible for exchange reporting.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "SenderReports",
        "description": "Indicates that party sending message will report trade"
      },
      {
        "value": "Y",
        "symbolicName": "ReceiverReports",
        "description": "Indicates that party receiving message must report trade"
      }
    ]
  },
  {
    "tag": "114",
    "name": "LocateReqd",
    "type": "Boolean",
    "description": "Indicates whether the broker is to locate the stock in conjunction with a short sell order.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "No",
        "description": "Indicates the broker is not required to locate"
      },
      {
        "value": "Y",
        "symbolicName": "Yes",
        "description": "Indicates the broker is responsible for locating the stock"
      }
    ]
  },
  {
    "tag": "115",
    "name": "OnBehalfOfCompID",
    "type": "String",
    "description": "Assigned value used to identify firm originating message if the message was delivered by a third party i.e. the third party firm identifier would be delivered in the SenderCompID field and the firm originating the message in this field."
  },
  {
    "tag": "116",
    "name": "OnBehalfOfSubID",
    "type": "String",
    "description": "Assigned value used to identify specific message originator (i.e. trader) if the message was delivered by a third party"
  },
  {
    "tag": "117",
    "name": "QuoteID",
    "type": "String",
    "description": "Unique identifier for quote"
  },
  {
    "tag": "118",
    "name": "NetMoney",
    "type": "Amt",
    "description": "Total amount due as the result of the transaction (e.g. for Buy order - principal + commission + fees) reported in currency of execution."
  },
  {
    "tag": "119",
    "name": "SettlCurrAmt",
    "type": "Amt",
    "description": "Total amount due expressed in settlement currency (includes the effect of the forex transaction)"
  },
  {
    "tag": "120",
    "name": "SettlCurrency",
    "type": "Currency",
    "description": "Currency code of settlement denomination."
  },
  {
    "tag": "121",
    "name": "ForexReq",
    "type": "Boolean",
    "description": "Indicates request for forex accommodation trade to be executed along with security transaction.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "DoNotExecuteForexAfterSecurityTrade",
        "description": "Do not execute Forex after security trade"
      },
      {
        "value": "Y",
        "symbolicName": "ExecuteForexAfterSecurityTrade",
        "description": "Execute Forex after security trade"
      }
    ]
  },
  {
    "tag": "122",
    "name": "OrigSendingTime",
    "type": "UTCTimestamp",
    "description": "Original time of message transmission (always expressed in UTC (Universal Time Coordinated, also known as \"GMT\") when transmitting orders as the result of a resend request."
  },
  {
    "tag": "123",
    "name": "GapFillFlag",
    "type": "Boolean",
    "description": "Indicates that the Sequence Reset message is replacing administrative or application messages which will not be resent.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "SequenceReset",
        "description": "Sequence Reset, ignore MsgSeqNum"
      },
      {
        "value": "Y",
        "symbolicName": "GapFillMessage",
        "description": "Gap Fill message, MsgSeqNum field valid"
      }
    ]
  },
  {
    "tag": "124",
    "name": "NoExecs",
    "type": "int",
    "description": "No of execution repeating group entries to follow."
  },
  {
    "tag": "125",
    "name": "CxlType",
    "type": "char",
    "description": "No longer used. Included here for reference to prior versions."
  },
  {
    "tag": "126",
    "name": "ExpireTime",
    "type": "UTCTimestamp",
    "description": "Time/Date of order expiration (always expressed in UTC (Universal Time Coordinated, also known as \"GMT\")"
  },
  {
    "tag": "127",
    "name": "DKReason",
    "type": "char",
    "description": "Reason for execution rejection.",
    "enum": [
      {
        "value": "A",
        "symbolicName": "UnknownSymbol",
        "description": "Unknown symbol"
      },
      {
        "value": "B",
        "symbolicName": "WrongSide",
        "description": "Wrong side"
      },
      {
        "value": "C",
        "symbolicName": "QuantityExceedsOrder",
        "description": "Quantity exceeds order"
      },
      {
        "value": "D",
        "symbolicName": "NoMatchingOrder",
        "description": "No matching order"
      },
      {
        "value": "E",
        "symbolicName": "PriceExceedsLimit",
        "description": "Price exceeds limit"
      },
      {
        "value": "Z",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "128",
    "name": "DeliverToCompID",
    "type": "String",
    "description": "Assigned value used to identify the firm targeted to receive the message if the message is delivered by a third party i.e. the third party firm identifier would be delivered in the TargetCompID field and the ultimate receiver firm ID in this field."
  },
  {
    "tag": "129",
    "name": "DeliverToSubID",
    "type": "String",
    "description": "Assigned value used to identify specific message recipient (i.e. trader) if the message is delivered by a third party"
  },
  {
    "tag": "130",
    "name": "IOINaturalFlag",
    "type": "Boolean",
    "description": "Indicates that IOI is the result of an existing agency order or a facilitation position resulting from an agency order, not from principal trading or order solicitation activity.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "NotNatural",
        "description": "Not natural"
      },
      {
        "value": "Y",
        "symbolicName": "Natural",
        "description": "Natural"
      }
    ]
  },
  {
    "tag": "131",
    "name": "QuoteReqID",
    "type": "String",
    "description": "Unique identifier for quote request"
  },
  {
    "tag": "132",
    "name": "BidPx",
    "type": "Price",
    "description": "Bid price/rate"
  },
  {
    "tag": "133",
    "name": "OfferPx",
    "type": "Price",
    "description": "Offer price/rate"
  },
  {
    "tag": "134",
    "name": "BidSize",
    "type": "Qty",
    "description": "Quantity of bid\n(Prior to FIX 4.2 this field was of type int)"
  },
  {
    "tag": "135",
    "name": "OfferSize",
    "type": "Qty",
    "description": "Quantity of offer\n(Prior to FIX 4.2 this field was of type int)"
  },
  {
    "tag": "136",
    "name": "NoMiscFees",
    "type": "int",
    "description": "Number of repeating groups of miscellaneous fees"
  },
  {
    "tag": "137",
    "name": "MiscFeeAmt",
    "type": "Amt",
    "description": "Miscellaneous fee value"
  },
  {
    "tag": "138",
    "name": "MiscFeeCurr",
    "type": "Currency",
    "description": "Currency of miscellaneous fee"
  },
  {
    "tag": "139",
    "name": "MiscFeeType",
    "type": "char",
    "description": "Indicates type of miscellaneous fee.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Regulatory",
        "description": "Regulatory (e.g. SEC)"
      },
      {
        "value": "2",
        "symbolicName": "Tax",
        "description": "Tax"
      },
      {
        "value": "3",
        "symbolicName": "LocalCommission",
        "description": "Local Commission"
      },
      {
        "value": "4",
        "symbolicName": "ExchangeFees",
        "description": "Exchange Fees"
      },
      {
        "value": "5",
        "symbolicName": "Stamp",
        "description": "Stamp"
      },
      {
        "value": "6",
        "symbolicName": "Levy",
        "description": "Levy"
      },
      {
        "value": "7",
        "symbolicName": "Other",
        "description": "Other"
      },
      {
        "value": "8",
        "symbolicName": "Markup",
        "description": "Markup"
      },
      {
        "value": "9",
        "symbolicName": "ConsumptionTax",
        "description": "Consumption Tax"
      }
    ]
  },
  {
    "tag": "140",
    "name": "PrevClosePx",
    "type": "Price",
    "description": "Previous closing price of security."
  },
  {
    "tag": "141",
    "name": "ResetSeqNumFlag",
    "type": "Boolean",
    "description": "Indicates that the both sides of the FIX session should reset sequence numbers.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "No",
        "description": "No"
      },
      {
        "value": "Y",
        "symbolicName": "Yes",
        "description": "Yes, reset sequence numbers"
      }
    ]
  },
  {
    "tag": "142",
    "name": "SenderLocationID",
    "type": "String",
    "description": "Assigned value used to identify specific message originator’s location (i.e. geographic location and/or desk, trader)"
  },
  {
    "tag": "143",
    "name": "TargetLocationID",
    "type": "String",
    "description": "Assigned value used to identify specific message destination’s location (i.e. geographic location and/or desk, trader)"
  },
  {
    "tag": "144",
    "name": "OnBehalfOfLocationID",
    "type": "String",
    "description": "Assigned value used to identify specific message originator’s location (i.e. geographic location and/or desk, trader) if the message was delivered by a third party"
  },
  {
    "tag": "145",
    "name": "DeliverToLocationID",
    "type": "String",
    "description": "Assigned value used to identify specific message recipient’s location (i.e. geographic location and/or desk, trader) if the message was delivered by a third party"
  },
  {
    "tag": "146",
    "name": "NoRelatedSym",
    "type": "int",
    "description": "Specifies the number of repeating symbols specified."
  },
  {
    "tag": "147",
    "name": "Subject",
    "type": "String",
    "description": "The subject of an Email message"
  },
  {
    "tag": "148",
    "name": "Headline",
    "type": "String",
    "description": "The headline of a News message"
  },
  {
    "tag": "149",
    "name": "URLLink",
    "type": "String",
    "description": "A URL (Uniform Resource Locator) link to additional information (i.e. http://www.XYZ.com/research.html)"
  },
  {
    "tag": "150",
    "name": "ExecType",
    "type": "char",
    "description": "Describes the specific ExecutionRpt (i.e. Pending Cancel) while OrdStatus will always identify the current order status (i.e. Partially Filled)",
    "enum": [
      {
        "value": "0",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "1",
        "symbolicName": "PartialFill",
        "description": "Partial fill"
      },
      {
        "value": "2",
        "symbolicName": "Fill",
        "description": "Fill"
      },
      {
        "value": "3",
        "symbolicName": "DoneForDay",
        "description": "Done for day"
      },
      {
        "value": "4",
        "symbolicName": "Canceled",
        "description": "Canceled"
      },
      {
        "value": "5",
        "symbolicName": "Replaced",
        "description": "Replace"
      },
      {
        "value": "6",
        "symbolicName": "PendingCancel",
        "description": "Pending Cancel (e.g. result of Order Cancel Request)"
      },
      {
        "value": "7",
        "symbolicName": "Stopped",
        "description": "Stopped"
      },
      {
        "value": "8",
        "symbolicName": "Rejected",
        "description": "Rejected"
      },
      {
        "value": "9",
        "symbolicName": "Suspended",
        "description": "Suspended"
      },
      {
        "value": "A",
        "symbolicName": "PendingNew",
        "description": "Pending New"
      },
      {
        "value": "B",
        "symbolicName": "Calculated",
        "description": "Calculated"
      },
      {
        "value": "C",
        "symbolicName": "Expired",
        "description": "Expired"
      },
      {
        "value": "D",
        "symbolicName": "Restated",
        "description": "Restated (ExecutionRpt sent unsolicited by sellside, with ExecRestatementReason set)"
      },
      {
        "value": "E",
        "symbolicName": "PendingReplace",
        "description": "Pending Replace (e.g. result of Order Cancel/Replace Request)"
      }
    ]
  },
  {
    "tag": "151",
    "name": "LeavesQty",
    "type": "Qty",
    "description": "Amount of shares open for further execution. If the OrdStatus is Canceled, DoneForTheDay, Expired, Calculated, or Rejected (in which case the order is no longer active) then LeavesQty could be 0, otherwise LeavesQty = OrderQty - CumQty.\n(Prior to FIX 4.2 this field was of type int)"
  },
  {
    "tag": "152",
    "name": "CashOrderQty",
    "type": "Qty",
    "description": "Specifies the approximate order quantity desired in total monetary units vs. as a number of shares. The broker would be responsible for converting and calculating a share quantity (OrderQty) based upon this amount to be used for the actual order and subsequent messages."
  },
  {
    "tag": "153",
    "name": "AllocAvgPx",
    "type": "Price",
    "description": "AvgPx for a specific AllocAccount"
  },
  {
    "tag": "154",
    "name": "AllocNetMoney",
    "type": "Amt",
    "description": "NetMoney for a specific AllocAccount"
  },
  {
    "tag": "155",
    "name": "SettlCurrFxRate",
    "type": "float",
    "description": "Foreign exchange rate used to compute SettlCurrAmt from Currency to SettlCurrency"
  },
  {
    "tag": "156",
    "name": "SettlCurrFxRateCalc",
    "type": "char",
    "description": "Specifies whether or not SettlCurrFxRate should be multiplied or divided."
  },
  {
    "tag": "157",
    "name": "NumDaysInterest",
    "type": "int",
    "description": "Number of Days of Interest for convertible bonds and fixed income"
  },
  {
    "tag": "158",
    "name": "AccruedInterestRate",
    "type": "float",
    "description": "Accrued Interest Rate for convertible bonds and fixed income"
  },
  {
    "tag": "159",
    "name": "AccruedInterestAmt",
    "type": "Amt",
    "description": "Amount of Accrued Interest for convertible bonds and fixed income"
  },
  {
    "tag": "160",
    "name": "SettlInstMode",
    "type": "char",
    "description": "Indicates mode used for Settlement Instructions",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Default",
        "description": "Default"
      },
      {
        "value": "1",
        "symbolicName": "StandingInstructionsProvided",
        "description": "Standing Instructions Provided"
      },
      {
        "value": "2",
        "symbolicName": "SpecificAllocationAccountOverriding",
        "description": "Specific Allocation Account Overriding"
      },
      {
        "value": "3",
        "symbolicName": "SpecificAllocationAccountStanding",
        "description": "Specific Allocation Account Standing"
      }
    ]
  },
  {
    "tag": "161",
    "name": "AllocText",
    "type": "String",
    "description": "Free format text related to a specific AllocAccount."
  },
  {
    "tag": "162",
    "name": "SettlInstID",
    "type": "String",
    "description": "Unique identifier for Settlement Instructions message."
  },
  {
    "tag": "163",
    "name": "SettlInstTransType",
    "type": "char",
    "description": "Settlement Instructions message transaction type",
    "enum": [
      {
        "value": "C",
        "symbolicName": "Cancel",
        "description": "Cancel"
      },
      {
        "value": "N",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "R",
        "symbolicName": "Replace",
        "description": "Replace"
      }
    ]
  },
  {
    "tag": "164",
    "name": "EmailThreadID",
    "type": "String",
    "description": "Unique identifier for an email thread (new and chain of replies)"
  },
  {
    "tag": "165",
    "name": "SettlInstSource",
    "type": "char",
    "description": "Indicates source of Settlement Instructions",
    "enum": [
      {
        "value": "1",
        "symbolicName": "BrokerCredit",
        "description": "Brokers Instructions"
      },
      {
        "value": "2",
        "symbolicName": "Institution",
        "description": "Institutions Instructions"
      }
    ]
  },
  {
    "tag": "166",
    "name": "SettlLocation",
    "type": "String",
    "description": "Identifies Settlement Depository or Country Code (ISITC spec)",
    "enum": [
      {
        "value": "CED",
        "symbolicName": "CEDEL",
        "description": "CEDEL"
      },
      {
        "value": "DTC",
        "symbolicName": "DepositoryTrustCompany",
        "description": "Depository Trust Company"
      },
      {
        "value": "EUR",
        "symbolicName": "EuroClear",
        "description": "Euroclear"
      },
      {
        "value": "FED",
        "symbolicName": "FederalBookEntry",
        "description": "Federal Book Entry"
      },
      {
        "value": "ISO Country Code",
        "symbolicName": "LocalMarketSettleLocation",
        "description": "Local Market Settle Location"
      },
      {
        "value": "PNY",
        "symbolicName": "Physical",
        "description": "Physical"
      },
      {
        "value": "PTC",
        "symbolicName": "ParticipantTrustCompany",
        "description": "Participant Trust Company"
      }
    ]
  },
  {
    "tag": "167",
    "name": "SecurityType",
    "type": "String",
    "description": "Indicates type of security (ISITC spec)",
    "enum": [
      {
        "value": "?",
        "symbolicName": "Wildcard",
        "description": "Wildcard entry (used on Security Definition Request message)"
      },
      {
        "value": "BA",
        "symbolicName": "BankersAcceptance",
        "description": "Bankers Acceptance"
      },
      {
        "value": "CB",
        "symbolicName": "ConvertibleBond",
        "description": "Convertible Bond (Note not part of ISITC spec)"
      },
      {
        "value": "CD",
        "symbolicName": "CertificateOfDeposit",
        "description": "Certificate Of Deposit"
      },
      {
        "value": "CMO",
        "symbolicName": "CollateralizedMortgageObligation",
        "description": "Collateralize Mortgage Obligation"
      },
      {
        "value": "CORP",
        "symbolicName": "CorporateBond",
        "description": "Corporate Bond"
      },
      {
        "value": "CP",
        "symbolicName": "CommercialPaper",
        "description": "Commercial Paper"
      },
      {
        "value": "CPP",
        "symbolicName": "CorporatePrivatePlacement",
        "description": "Corporate Private Placement"
      },
      {
        "value": "CS",
        "symbolicName": "CommonStock",
        "description": "Common Stock"
      },
      {
        "value": "FHA",
        "symbolicName": "FederalHousingAuthority",
        "description": "Federal Housing Authority"
      },
      {
        "value": "FHL",
        "symbolicName": "FederalHomeLoan",
        "description": "Federal Home Loan"
      },
      {
        "value": "FN",
        "symbolicName": "FederalNationalMortgageAssociation",
        "description": "Federal National Mortgage Association"
      },
      {
        "value": "FOR",
        "symbolicName": "ForeignExchangeContract",
        "description": "Foreign Exchange Contract"
      },
      {
        "value": "FUT",
        "symbolicName": "Future",
        "description": "Future"
      },
      {
        "value": "GN",
        "symbolicName": "GovernmentNationalMortgageAssociation",
        "description": "Government National Mortgage Association"
      },
      {
        "value": "GOVT",
        "symbolicName": "TreasuriesAgencyDebenture",
        "description": "Treasuries + Agency Debenture"
      },
      {
        "value": "IET",
        "symbolicName": "IOETTEMortgage",
        "description": "Mortgage IOETTE"
      },
      {
        "value": "MF",
        "symbolicName": "MutualFund",
        "description": "Mutual Fund"
      },
      {
        "value": "MIO",
        "symbolicName": "MortgageInterestOnly",
        "description": "Mortgage Interest Only"
      },
      {
        "value": "MPO",
        "symbolicName": "MortgagePrincipalOnly",
        "description": "Mortgage Principal Only"
      },
      {
        "value": "MPP",
        "symbolicName": "MortgagePrivatePlacement",
        "description": "Mortgage Private Placement"
      },
      {
        "value": "MPT",
        "symbolicName": "MiscellaneousPassThrough",
        "description": "Miscellaneous Pass-Thru"
      },
      {
        "value": "MUNI",
        "symbolicName": "MunicipalBond",
        "description": "Municipal Bond"
      },
      {
        "value": "NONE",
        "symbolicName": "NoSecurityType",
        "description": "No ISITC Security Type"
      },
      {
        "value": "OPT",
        "symbolicName": "Option",
        "description": "Option"
      },
      {
        "value": "PS",
        "symbolicName": "PreferredStock",
        "description": "Preferred Stock"
      },
      {
        "value": "RP",
        "symbolicName": "RepurchaseAgreement",
        "description": "Repurchase Agreement"
      },
      {
        "value": "RVRP",
        "symbolicName": "ReverseRepurchaseAgreement",
        "description": "Reverse Repurchase Agreement"
      },
      {
        "value": "SL",
        "symbolicName": "StudentLoanMarketingAssociation",
        "description": "Student Loan Marketing Association"
      },
      {
        "value": "TD",
        "symbolicName": "TimeDeposit",
        "description": "Time Deposit"
      },
      {
        "value": "USTB",
        "symbolicName": "USTreasuryBillOld",
        "description": "US Treasury Bill"
      },
      {
        "value": "WAR",
        "symbolicName": "Warrant",
        "description": "Warrant"
      },
      {
        "value": "ZOO",
        "symbolicName": "CatsTigersAndLions",
        "description": "Cats, Tigers & Lions (a real code: US Treasury Receipts)"
      }
    ]
  },
  {
    "tag": "168",
    "name": "EffectiveTime",
    "type": "UTCTimestamp",
    "description": "Time the details within the message should take effect (always expressed in UTC (Universal Time Coordinated, also known as \"GMT\")"
  },
  {
    "tag": "169",
    "name": "StandInstDbType",
    "type": "int",
    "description": "Identifies the Standing Instruction database used",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Other",
        "description": "Other"
      },
      {
        "value": "1",
        "symbolicName": "DTCSID",
        "description": "DTC SID"
      },
      {
        "value": "2",
        "symbolicName": "ThomsonALERT",
        "description": "Thomson ALERT"
      },
      {
        "value": "3",
        "symbolicName": "AGlobalCustodian",
        "description": "A Global Custodian (StandInstDbName must be provided)"
      }
    ]
  },
  {
    "tag": "170",
    "name": "StandInstDbName",
    "type": "String",
    "description": "Name of the Standing Instruction database represented with StandInstDbType (i.e. the Global Custodian’s name)."
  },
  {
    "tag": "171",
    "name": "StandInstDbID",
    "type": "String",
    "description": "Unique identifier used on the Standing Instructions database for the Standing Instructions to be referenced."
  },
  {
    "tag": "172",
    "name": "SettlDeliveryType",
    "type": "int",
    "description": "Identifies type of settlement"
  },
  {
    "tag": "173",
    "name": "SettlDepositoryCode",
    "type": "String",
    "description": "Broker’s account code at the depository (i.e. CEDEL ID for CEDEL, FINS for DTC, or Euroclear ID for Euroclear) if SettlLocation is a depository"
  },
  {
    "tag": "174",
    "name": "SettlBrkrCode",
    "type": "String",
    "description": "BIC (Bank Identification Code—Swift managed) code of the broker involved (i.e. for multi-company brokerage firms)"
  },
  {
    "tag": "175",
    "name": "SettlInstCode",
    "type": "String",
    "description": "BIC (Bank Identification Code—Swift managed) code of the institution involved (i.e. for multi-company institution firms)"
  },
  {
    "tag": "176",
    "name": "SecuritySettlAgentName",
    "type": "String",
    "description": "Name of SettlInstSource's local agent bank if SettlLocation is not a depository"
  },
  {
    "tag": "177",
    "name": "SecuritySettlAgentCode",
    "type": "String",
    "description": "BIC (Bank Identification Code--Swift managed) code of the SettlInstSource's local agent bank if SettlLocation is not a depository"
  },
  {
    "tag": "178",
    "name": "SecuritySettlAgentAcctNum",
    "type": "String",
    "description": "SettlInstSource's account number at local agent bank if SettlLocation is not a depository"
  },
  {
    "tag": "179",
    "name": "SecuritySettlAgentAcctName",
    "type": "String",
    "description": "Name of SettlInstSource's account at local agent bank if SettlLocation is not a depository"
  },
  {
    "tag": "180",
    "name": "SecuritySettlAgentContactName",
    "type": "String",
    "description": "Name of contact at local agent bank for SettlInstSource's account if SettlLocation is not a depository"
  },
  {
    "tag": "181",
    "name": "SecuritySettlAgentContactPhone",
    "type": "String",
    "description": "Phone number for contact at local agent bank if SettlLocation is not a depository"
  },
  {
    "tag": "182",
    "name": "CashSettlAgentName",
    "type": "String",
    "description": "Name of SettlInstSource's local agent bank if SettlDeliveryType=Free"
  },
  {
    "tag": "183",
    "name": "CashSettlAgentCode",
    "type": "String",
    "description": "BIC (Bank Identification Code--Swift managed) code of the SettlInstSource's local agent bank if SettlDeliveryType=Free"
  },
  {
    "tag": "184",
    "name": "CashSettlAgentAcctNum",
    "type": "String",
    "description": "SettlInstSource's account number at local agent bank if SettlDeliveryType=Free"
  },
  {
    "tag": "185",
    "name": "CashSettlAgentAcctName",
    "type": "String",
    "description": "Name of SettlInstSource's account at local agent bank if SettlDeliveryType=Free"
  },
  {
    "tag": "186",
    "name": "CashSettlAgentContactName",
    "type": "String",
    "description": "Name of contact at local agent bank for SettlInstSource's account if SettlDeliveryType=Free"
  },
  {
    "tag": "187",
    "name": "CashSettlAgentContactPhone",
    "type": "String",
    "description": "Phone number for contact at local agent bank for SettlInstSource's account if SettlDeliveryType=Free"
  },
  {
    "tag": "188",
    "name": "BidSpotRate",
    "type": "Price",
    "description": "Bid F/X spot rate.y vary and not limited to four)"
  },
  {
    "tag": "189",
    "name": "BidForwardPoints",
    "type": "PriceOffset",
    "description": "Bid F/X forward points added to spot rate. May be a negative value."
  },
  {
    "tag": "190",
    "name": "OfferSpotRate",
    "type": "Price",
    "description": "Offer F/X spot rate."
  },
  {
    "tag": "191",
    "name": "OfferForwardPoints",
    "type": "PriceOffset",
    "description": "Offer F/X forward points added to spot rate. May be a negative value."
  },
  {
    "tag": "192",
    "name": "OrderQty2",
    "type": "Qty",
    "description": "OrderQty of the future part of a F/X swap order."
  },
  {
    "tag": "193",
    "name": "FutSettDate2",
    "type": "LocalMktDate",
    "description": "FutSettDate of the future part of a F/X swap order."
  },
  {
    "tag": "194",
    "name": "LastSpotRate",
    "type": "Price",
    "description": "F/X spot rate."
  },
  {
    "tag": "195",
    "name": "LastForwardPoints",
    "type": "PriceOffset",
    "description": "F/X forward points added to LastSpotRate. May be a negative value."
  },
  {
    "tag": "196",
    "name": "AllocLinkID",
    "type": "String",
    "description": "Can be used to link two different Allocation messages (each with unique AllocID) together, i.e. for F/X \"Netting\" or \"Swaps\". Should be unique."
  },
  {
    "tag": "197",
    "name": "AllocLinkType",
    "type": "int",
    "description": "Identifies the type of Allocation linkage when AllocLinkID is used.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "FXNetting",
        "description": "F/X Netting"
      },
      {
        "value": "1",
        "symbolicName": "FXSwap",
        "description": "F/X Swap"
      }
    ]
  },
  {
    "tag": "198",
    "name": "SecondaryOrderID",
    "type": "String",
    "description": "Assigned by the party which accepts the order. Can be used to provide the OrderID used by an exchange or executing system."
  },
  {
    "tag": "199",
    "name": "NoIOIQualifiers",
    "type": "int",
    "description": "Number of repeating groups of IOIQualifiers."
  },
  {
    "tag": "200",
    "name": "MaturityMonthYear",
    "type": "MonthYear",
    "description": "Month and Year of the maturity for SecurityType=FUT or SecurityType=OPT. Required if MaturityDay is specified.\nFormat: YYYYMM\n(i.e. 199903)"
  },
  {
    "tag": "201",
    "name": "PutOrCall",
    "type": "int",
    "description": "Indicates whether an Option is for a put or call.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Put",
        "description": "Put"
      },
      {
        "value": "1",
        "symbolicName": "Call",
        "description": "Call"
      }
    ]
  },
  {
    "tag": "202",
    "name": "StrikePrice",
    "type": "Price",
    "description": "Strike Price for an Option."
  },
  {
    "tag": "203",
    "name": "CoveredOrUncovered",
    "type": "int",
    "description": "Used for options",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Covered",
        "description": "Covered"
      },
      {
        "value": "1",
        "symbolicName": "Uncovered",
        "description": "Uncovered"
      }
    ]
  },
  {
    "tag": "204",
    "name": "CustomerOrFirm",
    "type": "int",
    "description": "Used for options when delivering the order to an execution system/exchange to specify if the order is for a customer or the firm placing the order itself.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Customer",
        "description": "Customer"
      },
      {
        "value": "1",
        "symbolicName": "Firm",
        "description": "Firm"
      }
    ]
  },
  {
    "tag": "205",
    "name": "MaturityDay",
    "type": "DayOfMonth",
    "description": "Day of month used in conjunction with MaturityMonthYear to specify the maturity date for SecurityType=FUT or SecurityType=OPT."
  },
  {
    "tag": "206",
    "name": "OptAttribute",
    "type": "char",
    "description": "Can be used for SecurityType=OPT to identify a particular security."
  },
  {
    "tag": "207",
    "name": "SecurityExchange",
    "type": "Exchange",
    "description": "Market used to help identify a security."
  },
  {
    "tag": "208",
    "name": "NotifyBrokerOfCredit",
    "type": "Boolean",
    "description": "Indicates whether or not details should be communicated to BrokerOfCredit (i.e. step-in broker).",
    "enum": [
      {
        "value": "N",
        "symbolicName": "DetailsShouldNotBeCommunicated",
        "description": "Details should not be communicated"
      },
      {
        "value": "Y",
        "symbolicName": "DetailsShouldBeCommunicated",
        "description": "Details should be communicated"
      }
    ]
  },
  {
    "tag": "209",
    "name": "AllocHandlInst",
    "type": "int",
    "description": "Indicates how the receiver (i.e. third party) of Allocation message should handle/process the account details.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Match",
        "description": "Match"
      },
      {
        "value": "2",
        "symbolicName": "Forward",
        "description": "Forward"
      },
      {
        "value": "3",
        "symbolicName": "ForwardAndMatch",
        "description": "Forward and Match"
      }
    ]
  },
  {
    "tag": "210",
    "name": "MaxShow",
    "type": "Qty",
    "description": "Maximum number of shares within an order to be shown to other customers (i.e. sent via an IOI).\n(Prior to FIX 4.2 this field was of type int)"
  },
  {
    "tag": "211",
    "name": "PegDifference",
    "type": "PriceOffset",
    "description": "Amount (signed) added to the price of the peg for a pegged order."
  },
  {
    "tag": "212",
    "name": "XmlDataLen",
    "type": "Length",
    "description": "Length of the XmlData data block."
  },
  {
    "tag": "213",
    "name": "XmlData",
    "type": "data",
    "description": "Actual XML data stream (e.g. FIXML). See approriate XML reference (e.g. FIXML). Note: may contain embedded SOH characters."
  },
  {
    "tag": "214",
    "name": "SettlInstRefID",
    "type": "String",
    "description": "Reference identifier for the SettlInstID with Cancel and Replace SettlInstTransType transaction types."
  },
  {
    "tag": "215",
    "name": "NoRoutingIDs",
    "type": "int",
    "description": "Number of repeating groups of RoutingID and RoutingType values.\nSee Appendix L – Pre-Trade Message Targeting/Routing"
  },
  {
    "tag": "216",
    "name": "RoutingType",
    "type": "int",
    "description": "Indicates the type of RoutingID specified.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "TargetFirm",
        "description": "Target Firm"
      },
      {
        "value": "2",
        "symbolicName": "TargetList",
        "description": "Target List"
      },
      {
        "value": "3",
        "symbolicName": "BlockFirm",
        "description": "Block Firm"
      },
      {
        "value": "4",
        "symbolicName": "BlockList",
        "description": "Block List"
      }
    ]
  },
  {
    "tag": "217",
    "name": "RoutingID",
    "type": "String",
    "description": "Assigned value used to identify a specific routing destination."
  },
  {
    "tag": "218",
    "name": "SpreadToBenchmark",
    "type": "PriceOffset",
    "description": "For Fixed Income. Basis points relative to a benchmark. To be expressed as \"count of basis points\" (vs. an absolute value). E.g. High Grade Corporate Bonds may express price as basis points relative to benchmark (the Benchmark field). Note: Basis points can be negative."
  },
  {
    "tag": "219",
    "name": "Benchmark",
    "type": "char",
    "description": "For Fixed Income. Identifies the benchmark (e.g. used in conjunction with the SpreadToBenchmark field).",
    "enum": [
      {
        "value": "1",
        "symbolicName": "CURVE",
        "description": "CURVE"
      },
      {
        "value": "2",
        "symbolicName": "FiveYR",
        "description": "5-YR"
      },
      {
        "value": "3",
        "symbolicName": "OLD5",
        "description": "OLD-5"
      },
      {
        "value": "4",
        "symbolicName": "TenYR",
        "description": "10-YR"
      },
      {
        "value": "5",
        "symbolicName": "OLD10",
        "description": "OLD-10"
      },
      {
        "value": "6",
        "symbolicName": "ThirtyYR",
        "description": "30-YR"
      },
      {
        "value": "7",
        "symbolicName": "OLD30",
        "description": "OLD-30"
      },
      {
        "value": "8",
        "symbolicName": "ThreeMOLIBOR",
        "description": "3-MO-LIBOR"
      },
      {
        "value": "9",
        "symbolicName": "SixMOLIBOR",
        "description": "6-MO-LIBOR"
      }
    ]
  },
  {
    "tag": "223",
    "name": "CouponRate",
    "type": "float",
    "description": "For Fixed Income. Coupon rate of the bond. Will be zero for step-up bonds."
  },
  {
    "tag": "231",
    "name": "ContractMultiplier",
    "type": "float",
    "description": "Specifies the ratio or multiply factor to convert from contracts to shares (e.g. 1.0, 100, 1000, etc). Applicable For Fixed Income, Convertible Bonds, Derivatives, etc. Note: If used, quantities should be expressed in the \"nominal\" (e.g. contracts vs. shares) amount."
  },
  {
    "tag": "262",
    "name": "MDReqID",
    "type": "String",
    "description": "Unique identifier for Market Data Request"
  },
  {
    "tag": "263",
    "name": "SubscriptionRequestType",
    "type": "char",
    "description": "Subscription Request Type",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Snapshot",
        "description": "Snapshot"
      },
      {
        "value": "1",
        "symbolicName": "SnapshotAndUpdates",
        "description": "Snapshot + Updates (Subscribe)"
      },
      {
        "value": "2",
        "symbolicName": "DisablePreviousSnapshot",
        "description": "Disable previous Snapshot + Update Request (Unsubscribe)"
      }
    ]
  },
  {
    "tag": "264",
    "name": "MarketDepth",
    "type": "int",
    "description": "Depth of market for Book Snapshot"
  },
  {
    "tag": "265",
    "name": "MDUpdateType",
    "type": "int",
    "description": "Specifies the type of Market Data update.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "FullRefresh",
        "description": "Full Refresh"
      },
      {
        "value": "1",
        "symbolicName": "IncrementalRefresh",
        "description": "Incremental Refresh"
      }
    ]
  },
  {
    "tag": "266",
    "name": "AggregatedBook",
    "type": "Boolean",
    "description": "Specifies whether or not book entries should be aggregated.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "BookEntriesShouldNotBeAggregated",
        "description": "Multiple entries per side per price allowed"
      },
      {
        "value": "Y",
        "symbolicName": "BookEntriesToBeAggregated",
        "description": "one book entry per side per price"
      }
    ]
  },
  {
    "tag": "267",
    "name": "NoMDEntryTypes",
    "type": "int",
    "description": "Number of MDEntryType fields requested."
  },
  {
    "tag": "268",
    "name": "NoMDEntries",
    "type": "int",
    "description": "Number of entries in Market Data message."
  },
  {
    "tag": "269",
    "name": "MDEntryType",
    "type": "char",
    "description": "Type Market Data entry.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Bid",
        "description": "Bid"
      },
      {
        "value": "1",
        "symbolicName": "Offer",
        "description": "Offer"
      },
      {
        "value": "2",
        "symbolicName": "Trade",
        "description": "Trade"
      },
      {
        "value": "3",
        "symbolicName": "IndexValue",
        "description": "Index Value"
      },
      {
        "value": "4",
        "symbolicName": "OpeningPrice",
        "description": "Opening Price"
      },
      {
        "value": "5",
        "symbolicName": "ClosingPrice",
        "description": "Closing Price"
      },
      {
        "value": "6",
        "symbolicName": "SettlementPrice",
        "description": "Settlement Price"
      },
      {
        "value": "7",
        "symbolicName": "TradingSessionHighPrice",
        "description": "Trading Session High Price"
      },
      {
        "value": "8",
        "symbolicName": "TradingSessionLowPrice",
        "description": "Trading Session Low Price"
      },
      {
        "value": "9",
        "symbolicName": "TradingSessionVWAPPrice",
        "description": "Trading Session VWAP Price"
      }
    ]
  },
  {
    "tag": "270",
    "name": "MDEntryPx",
    "type": "Price",
    "description": "Price of the Market Data Entry."
  },
  {
    "tag": "271",
    "name": "MDEntrySize",
    "type": "Qty",
    "description": "Number of shares represented by the Market Data Entry."
  },
  {
    "tag": "272",
    "name": "MDEntryDate",
    "type": "UTCDate",
    "description": "Date of Market Data Entry."
  },
  {
    "tag": "273",
    "name": "MDEntryTime",
    "type": "UTCTimeOnly",
    "description": "Time of Market Data Entry."
  },
  {
    "tag": "274",
    "name": "TickDirection",
    "type": "char",
    "description": "Direction of the \"tick\".",
    "enum": [
      {
        "value": "0",
        "symbolicName": "PlusTick",
        "description": "Plus Tick"
      },
      {
        "value": "1",
        "symbolicName": "ZeroPlusTick",
        "description": "Zero-Plus Tick"
      },
      {
        "value": "2",
        "symbolicName": "MinusTick",
        "description": "Minus Tick"
      },
      {
        "value": "3",
        "symbolicName": "ZeroMinusTick",
        "description": "Zero-Minus Tick"
      }
    ]
  },
  {
    "tag": "275",
    "name": "MDMkt",
    "type": "Exchange",
    "description": "Market posting quote / trade.\nValid values:\nSee Appendix C"
  },
  {
    "tag": "276",
    "name": "QuoteCondition",
    "type": "MultipleValueString",
    "description": "Space-delimited list of conditions describing a quote.",
    "enum": [
      {
        "value": "A",
        "symbolicName": "Open",
        "description": "Open / Active"
      },
      {
        "value": "B",
        "symbolicName": "Closed",
        "description": "Closed / Inactive"
      },
      {
        "value": "C",
        "symbolicName": "ExchangeBest",
        "description": "Exchange Best"
      },
      {
        "value": "D",
        "symbolicName": "ConsolidatedBest",
        "description": "Consolidated Best"
      },
      {
        "value": "E",
        "symbolicName": "Locked",
        "description": "Locked"
      },
      {
        "value": "F",
        "symbolicName": "Crossed",
        "description": "Crossed"
      },
      {
        "value": "G",
        "symbolicName": "Depth",
        "description": "Depth"
      },
      {
        "value": "H",
        "symbolicName": "FastTrading",
        "description": "Fast Trading"
      },
      {
        "value": "I",
        "symbolicName": "NonFirm",
        "description": "Non-Firm"
      }
    ]
  },
  {
    "tag": "277",
    "name": "TradeCondition",
    "type": "MultipleValueString",
    "description": "Space-delimited list of conditions describing a trade",
    "enum": [
      {
        "value": "A",
        "symbolicName": "Cash",
        "description": "Cash (only) Market"
      },
      {
        "value": "B",
        "symbolicName": "AveragePriceTrade",
        "description": "Average Price Trade"
      },
      {
        "value": "C",
        "symbolicName": "CashTrade",
        "description": "Cash Trade (same day clearing)"
      },
      {
        "value": "D",
        "symbolicName": "NextDay",
        "description": "Next Day (only) Market"
      },
      {
        "value": "E",
        "symbolicName": "Opening",
        "description": "Opening / Reopening Trade Detail"
      },
      {
        "value": "F",
        "symbolicName": "IntradayTradeDetail",
        "description": "Intraday Trade Detail"
      },
      {
        "value": "G",
        "symbolicName": "Rule127Trade",
        "description": "Rule 127 Trade (NYSE)"
      },
      {
        "value": "H",
        "symbolicName": "Rule155Trade",
        "description": "Rule 155 Trade (Amex)"
      },
      {
        "value": "I",
        "symbolicName": "SoldLast",
        "description": "Sold Last (late reporting)"
      },
      {
        "value": "J",
        "symbolicName": "NextDayTrade",
        "description": "Next Day Trade (next day clearing)"
      },
      {
        "value": "K",
        "symbolicName": "Opened",
        "description": "Opened (late report of opened trade)"
      },
      {
        "value": "L",
        "symbolicName": "Seller",
        "description": "Seller"
      },
      {
        "value": "M",
        "symbolicName": "Sold",
        "description": "Sold (out of sequence)"
      },
      {
        "value": "N",
        "symbolicName": "StoppedStock",
        "description": "Stopped Stock (guarantee of price but does not execute the order)"
      }
    ]
  },
  {
    "tag": "278",
    "name": "MDEntryID",
    "type": "String",
    "description": "Unique Market Data Entry identifier."
  },
  {
    "tag": "279",
    "name": "MDUpdateAction",
    "type": "char",
    "description": "Type of Market Data update action.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "1",
        "symbolicName": "Change",
        "description": "Change"
      },
      {
        "value": "2",
        "symbolicName": "Delete",
        "description": "Delete"
      }
    ]
  },
  {
    "tag": "280",
    "name": "MDEntryRefID",
    "type": "String",
    "description": "Refers to a previous MDEntryID."
  },
  {
    "tag": "281",
    "name": "MDReqRejReason",
    "type": "char",
    "description": "Reason for the rejection of a Market Data request.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "UnknownSymbol",
        "description": "Unknown symbol"
      },
      {
        "value": "1",
        "symbolicName": "DuplicateMDReqID",
        "description": "Duplicate MDReqID"
      },
      {
        "value": "2",
        "symbolicName": "InsufficientBandwidth",
        "description": "Insufficient Bandwidth"
      },
      {
        "value": "3",
        "symbolicName": "InsufficientPermissions",
        "description": "Insufficient Permissions"
      },
      {
        "value": "4",
        "symbolicName": "UnsupportedSubscriptionRequestType",
        "description": "Unsupported SubscriptionRequestType"
      },
      {
        "value": "5",
        "symbolicName": "UnsupportedMarketDepth",
        "description": "Unsupported MarketDepth"
      },
      {
        "value": "6",
        "symbolicName": "UnsupportedMDUpdateType",
        "description": "Unsupported MDUpdateType"
      },
      {
        "value": "7",
        "symbolicName": "UnsupportedAggregatedBook",
        "description": "Unsupported AggregatedBook"
      },
      {
        "value": "8",
        "symbolicName": "UnsupportedMDEntryType",
        "description": "Unsupported MDEntryType"
      }
    ]
  },
  {
    "tag": "282",
    "name": "MDEntryOriginator",
    "type": "String",
    "description": "Originator of a Market Data Entry"
  },
  {
    "tag": "283",
    "name": "LocationID",
    "type": "String",
    "description": "Identification of a Market Maker’s location"
  },
  {
    "tag": "284",
    "name": "DeskID",
    "type": "String",
    "description": "Identification of a Market Maker’s desk"
  },
  {
    "tag": "285",
    "name": "DeleteReason",
    "type": "char",
    "description": "Reason for deletion.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Cancellation",
        "description": "Cancelation / Trade Bust"
      },
      {
        "value": "1",
        "symbolicName": "Error",
        "description": "Error"
      }
    ]
  },
  {
    "tag": "286",
    "name": "OpenCloseSettleFlag",
    "type": "char",
    "description": "Flag that identifies a price.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "DailyOpen",
        "description": "Daily Open / Close / Settlement price"
      },
      {
        "value": "1",
        "symbolicName": "SessionOpen",
        "description": "Session Open / Close / Settlement price"
      },
      {
        "value": "2",
        "symbolicName": "DeliverySettlementEntry",
        "description": "Delivery Settlement price"
      }
    ]
  },
  {
    "tag": "287",
    "name": "SellerDays",
    "type": "int",
    "description": "Specifies the number of days that may elapse before delivery of the security"
  },
  {
    "tag": "288",
    "name": "MDEntryBuyer",
    "type": "String",
    "description": "Buying party in a trade"
  },
  {
    "tag": "289",
    "name": "MDEntrySeller",
    "type": "String",
    "description": "Selling party in a trade"
  },
  {
    "tag": "290",
    "name": "MDEntryPositionNo",
    "type": "int",
    "description": "Display position of a bid or offer, numbered from most competitive to least competitive, per market side, beginning with 1."
  },
  {
    "tag": "291",
    "name": "FinancialStatus",
    "type": "char",
    "description": "Identifies a firm’s financial status.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Bankrupt",
        "description": "Bankrupt"
      }
    ]
  },
  {
    "tag": "292",
    "name": "CorporateAction",
    "type": "char",
    "description": "Identifies the type of Corporate Action.",
    "enum": [
      {
        "value": "A",
        "symbolicName": "ExDividend",
        "description": "Ex-Dividend"
      },
      {
        "value": "B",
        "symbolicName": "ExDistribution",
        "description": "Ex-Distribution"
      },
      {
        "value": "C",
        "symbolicName": "ExRights",
        "description": "Ex-Rights"
      },
      {
        "value": "D",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "E",
        "symbolicName": "ExInterest",
        "description": "Ex-Interest"
      }
    ]
  },
  {
    "tag": "293",
    "name": "DefBidSize",
    "type": "Qty",
    "description": "Default Bid Size."
  },
  {
    "tag": "294",
    "name": "DefOfferSize",
    "type": "Qty",
    "description": "Default Offer Size."
  },
  {
    "tag": "295",
    "name": "NoQuoteEntries",
    "type": "int",
    "description": "The number of quote entries for a QuoteSet."
  },
  {
    "tag": "296",
    "name": "NoQuoteSets",
    "type": "int",
    "description": "The number of sets of quotes in the message."
  },
  {
    "tag": "297",
    "name": "QuoteAckStatus",
    "type": "int",
    "description": "Identifies the status of the quote acknowledgement.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Accepted",
        "description": "Accepted"
      },
      {
        "value": "1",
        "symbolicName": "CancelForSymbol",
        "description": "Canceled for Symbol(s)"
      },
      {
        "value": "2",
        "symbolicName": "CanceledForSecurityType",
        "description": "Canceled for Security Type(s)"
      },
      {
        "value": "3",
        "symbolicName": "CanceledForUnderlying",
        "description": "Canceled for Underlying"
      },
      {
        "value": "4",
        "symbolicName": "CanceledAll",
        "description": "Canceled All"
      },
      {
        "value": "5",
        "symbolicName": "Rejected",
        "description": "Rejected"
      }
    ]
  },
  {
    "tag": "298",
    "name": "QuoteCancelType",
    "type": "int",
    "description": "Identifies the type of quote cancel.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "CancelForOneOrMoreSecurities",
        "description": "Cancel for Symbol(s)"
      },
      {
        "value": "2",
        "symbolicName": "CancelForSecurityType",
        "description": "Cancel for Security Type(s)"
      },
      {
        "value": "3",
        "symbolicName": "CancelForUnderlyingSecurity",
        "description": "Cancel for Underlying Symbol"
      },
      {
        "value": "4",
        "symbolicName": "CancelAllQuotes",
        "description": "Cancel for All Quotes"
      }
    ]
  },
  {
    "tag": "299",
    "name": "QuoteEntryID",
    "type": "String",
    "description": "Uniquely identifies the quote as part of a QuoteSet."
  },
  {
    "tag": "300",
    "name": "QuoteRejectReason",
    "type": "int",
    "description": "Reason Quote was rejected:",
    "enum": [
      {
        "value": "1",
        "symbolicName": "UnknownSymbol",
        "description": "Unknown symbol (Security)"
      },
      {
        "value": "2",
        "symbolicName": "Exchange",
        "description": "Exchange (Security) closed"
      },
      {
        "value": "3",
        "symbolicName": "QuoteRequestExceedsLimit",
        "description": "Quote Request exceeds limit"
      },
      {
        "value": "4",
        "symbolicName": "TooLateToEnter",
        "description": "Too late to enter"
      },
      {
        "value": "5",
        "symbolicName": "UnknownQuote",
        "description": "Unknown Quote"
      },
      {
        "value": "6",
        "symbolicName": "DuplicateQuote",
        "description": "Duplicate Quote"
      },
      {
        "value": "7",
        "symbolicName": "InvalidBid",
        "description": "Invalid bid/ask spread"
      },
      {
        "value": "8",
        "symbolicName": "InvalidPrice",
        "description": "Invalid price"
      },
      {
        "value": "9",
        "symbolicName": "NotAuthorizedToQuoteSecurity",
        "description": "Not authorized to quote security"
      }
    ]
  },
  {
    "tag": "301",
    "name": "QuoteResponseLevel",
    "type": "int",
    "description": "Level of Response requested from receiver of quote messages.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "NoAcknowledgement",
        "description": "No Acknowledgement (Default)"
      },
      {
        "value": "1",
        "symbolicName": "AcknowledgeOnlyNegativeOrErroneousQuotes",
        "description": "Acknowledge only negative or erroneous quotes"
      },
      {
        "value": "2",
        "symbolicName": "AcknowledgeEachQuoteMessage",
        "description": "Acknowledge each quote messages"
      }
    ]
  },
  {
    "tag": "302",
    "name": "QuoteSetID",
    "type": "String",
    "description": "Unique id for the Quote Set."
  },
  {
    "tag": "303",
    "name": "QuoteRequestType",
    "type": "int",
    "description": "Indicates the type of Quote Request being generated",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Manual",
        "description": "Manual"
      },
      {
        "value": "2",
        "symbolicName": "Automatic",
        "description": "Automatic"
      }
    ]
  },
  {
    "tag": "304",
    "name": "TotQuoteEntries",
    "type": "int",
    "description": "Total number of quotes for the quote set across all messages. Should be the sum of all NoQuoteEntries in each message that has repeating quotes that are part of the same quote set."
  },
  {
    "tag": "305",
    "name": "UnderlyingIDSource",
    "type": "String",
    "description": "Underlying security’s IDSource."
  },
  {
    "tag": "306",
    "name": "UnderlyingIssuer",
    "type": "String",
    "description": "Underlying security’s Issuer.\nSee Issuer field for description"
  },
  {
    "tag": "307",
    "name": "UnderlyingSecurityDesc",
    "type": "String",
    "description": "Underlying security’s SecurityDesc.\nSee SecurityDesc field for description"
  },
  {
    "tag": "308",
    "name": "UnderlyingSecurityExchange",
    "type": "Exchange",
    "description": "Underlying security’s SecurityExchange. Can be used to identify the underlying security."
  },
  {
    "tag": "309",
    "name": "UnderlyingSecurityID",
    "type": "String",
    "description": "Underlying security’s SecurityID.\nSee SecurityID field for description"
  },
  {
    "tag": "310",
    "name": "UnderlyingSecurityType",
    "type": "String",
    "description": "Underlying security’s SecurityType."
  },
  {
    "tag": "311",
    "name": "UnderlyingSymbol",
    "type": "String",
    "description": "Underlying security’s Symbol.\nSee Symbol field for description"
  },
  {
    "tag": "312",
    "name": "UnderlyingSymbolSfx",
    "type": "String",
    "description": "Underlying security’s SymbolSfx.\nSee SymbolSfx field for description"
  },
  {
    "tag": "313",
    "name": "UnderlyingMaturityMonthYear",
    "type": "MonthYear",
    "description": "Underlying security’s MaturityMonthYear. Required if UnderlyingMaturityDay is specified.\nSee MaturityMonthYear field for description"
  },
  {
    "tag": "314",
    "name": "UnderlyingMaturityDay",
    "type": "DayOfMonth",
    "description": "Underlying security’s MaturityDay.\nSee MaturityDay field for description"
  },
  {
    "tag": "315",
    "name": "UnderlyingPutOrCall",
    "type": "int",
    "description": "Underlying security’s PutOrCall.\nSee PutOrCall field for description"
  },
  {
    "tag": "316",
    "name": "UnderlyingStrikePrice",
    "type": "Price",
    "description": "Underlying security’s StrikePrice.\nSee StrikePrice field for description"
  },
  {
    "tag": "317",
    "name": "UnderlyingOptAttribute",
    "type": "char",
    "description": "Underlying security’s OptAttribute.\nSee OptAttribute field for description"
  },
  {
    "tag": "318",
    "name": "UnderlyingCurrency",
    "type": "Currency",
    "description": "Underlying security’s Currency.\nSee Currency field for description and valid values"
  },
  {
    "tag": "319",
    "name": "RatioQty",
    "type": "Qty",
    "description": "Quantity of a particular leg in the security."
  },
  {
    "tag": "320",
    "name": "SecurityReqID",
    "type": "String",
    "description": "Unique ID of a Security Definition Request."
  },
  {
    "tag": "321",
    "name": "SecurityRequestType",
    "type": "int",
    "description": "Type of Security Definition Request.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "RequestSecurityIdentityAndSpecifications",
        "description": "Request Security identity and specifications"
      },
      {
        "value": "1",
        "symbolicName": "RequestSecurityIdentityForSpecifications",
        "description": "Request Security identity for the specifications provided (Name of the security is not supplied)"
      },
      {
        "value": "2",
        "symbolicName": "RequestListSecurityTypes",
        "description": "Request List Security Types"
      },
      {
        "value": "3",
        "symbolicName": "RequestListSecurities",
        "description": "Request List Securities (Can be qualified with Symbol, SecurityType, TradingSessionID, SecurityExchange is provided then only list Securities for the specific type)"
      }
    ]
  },
  {
    "tag": "322",
    "name": "SecurityResponseID",
    "type": "String",
    "description": "Unique ID of a Security Definition message."
  },
  {
    "tag": "323",
    "name": "SecurityResponseType",
    "type": "int",
    "description": "Type of Security Definition message response.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "AcceptAsIs",
        "description": "Accept security proposal as is"
      },
      {
        "value": "2",
        "symbolicName": "AcceptWithRevisions",
        "description": "Accept security proposal with revisions as indicated in the message"
      },
      {
        "value": "3",
        "symbolicName": "ListOfSecurityTypesReturnedPerRequest",
        "description": "List of security types returned per request"
      },
      {
        "value": "4",
        "symbolicName": "ListOfSecuritiesReturnedPerRequest",
        "description": "List of securities returned per request"
      },
      {
        "value": "5",
        "symbolicName": "RejectSecurityProposal",
        "description": "Reject security proposal"
      },
      {
        "value": "6",
        "symbolicName": "CannotMatchSelectionCriteria",
        "description": "Can not match selection criteria"
      }
    ]
  },
  {
    "tag": "324",
    "name": "SecurityStatusReqID",
    "type": "String",
    "description": "Unique ID of a Security Status Request message."
  },
  {
    "tag": "325",
    "name": "UnsolicitedIndicator",
    "type": "Boolean",
    "description": "Indicates whether or not message is being sent as a result of a subscription request or not.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "MessageIsBeingSentAsAResultOfAPriorRequest",
        "description": "Message is being sent as a result of a prior request"
      },
      {
        "value": "Y",
        "symbolicName": "MessageIsBeingSentUnsolicited",
        "description": "Message is being sent unsolicited"
      }
    ]
  },
  {
    "tag": "326",
    "name": "SecurityTradingStatus",
    "type": "int",
    "description": "Identifies the trading status applicable to the transaction.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "OpeningDelay",
        "description": "Opening Delay"
      },
      {
        "value": "10",
        "symbolicName": "MarketOnCloseImbalanceSell",
        "description": "Market On Close Imbalance Sell"
      },
      {
        "value": "12",
        "symbolicName": "NoMarketImbalance",
        "description": "No Market Imbalance"
      },
      {
        "value": "13",
        "symbolicName": "NoMarketOnCloseImbalance",
        "description": "No Market On Close Imbalance"
      },
      {
        "value": "14",
        "symbolicName": "ITSPreOpening",
        "description": "ITS Pre-Opening"
      },
      {
        "value": "15",
        "symbolicName": "NewPriceIndication",
        "description": "New Price Indication"
      },
      {
        "value": "16",
        "symbolicName": "TradeDisseminationTime",
        "description": "Trade Dissemination Time"
      },
      {
        "value": "17",
        "symbolicName": "ReadyToTrade",
        "description": "Ready to trade (start of session)"
      },
      {
        "value": "18",
        "symbolicName": "NotAvailableForTrading",
        "description": "Not Available for trading (end of session)"
      },
      {
        "value": "19",
        "symbolicName": "NotTradedOnThisMarket",
        "description": "Not Traded on this Market"
      },
      {
        "value": "2",
        "symbolicName": "TradingHalt",
        "description": "Trading Halt"
      },
      {
        "value": "20",
        "symbolicName": "UnknownOrInvalid",
        "description": "Unknown or Invalid"
      },
      {
        "value": "3",
        "symbolicName": "Resume",
        "description": "Resume"
      },
      {
        "value": "4",
        "symbolicName": "NoOpen",
        "description": "No Open/No Resume"
      },
      {
        "value": "5",
        "symbolicName": "PriceIndication",
        "description": "Price Indication"
      },
      {
        "value": "6",
        "symbolicName": "TradingRangeIndication",
        "description": "Trading Range Indication"
      },
      {
        "value": "7",
        "symbolicName": "MarketImbalanceBuy",
        "description": "Market Imbalance Buy"
      },
      {
        "value": "8",
        "symbolicName": "MarketImbalanceSell",
        "description": "Market Imbalance Sell"
      },
      {
        "value": "9",
        "symbolicName": "MarketOnCloseImbalanceBuy",
        "description": "Market On Close Imbalance Buy"
      }
    ]
  },
  {
    "tag": "327",
    "name": "HaltReason",
    "type": "char",
    "description": "Denotes the reason for the Opening Delay or Trading Halt.",
    "enum": [
      {
        "value": "D",
        "symbolicName": "NewsDissemination",
        "description": "News Dissemination"
      },
      {
        "value": "E",
        "symbolicName": "OrderInflux",
        "description": "Order Influx"
      },
      {
        "value": "I",
        "symbolicName": "OrderImbalance",
        "description": "Order Imbalance"
      },
      {
        "value": "M",
        "symbolicName": "AdditionalInformation",
        "description": "Additional Information"
      },
      {
        "value": "P",
        "symbolicName": "NewsPending",
        "description": "News Pending"
      },
      {
        "value": "X",
        "symbolicName": "EquipmentChangeover",
        "description": "Equipment Changeover"
      }
    ]
  },
  {
    "tag": "328",
    "name": "InViewOfCommon",
    "type": "Boolean",
    "description": "Indicates whether or not the halt was due to Common Stock trading being halted.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "HaltWasNotRelatedToAHaltOfTheCommonStock",
        "description": "Halt was not related to a halt of the common stock"
      },
      {
        "value": "Y",
        "symbolicName": "HaltWasDueToCommonStockBeingHalted",
        "description": "Halt was due to common stock being halted"
      }
    ]
  },
  {
    "tag": "329",
    "name": "DueToRelated",
    "type": "Boolean",
    "description": "Indicates whether or not the halt was due to the Related Security being halted.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "NotRelatedToSecurityHalt",
        "description": "Halt was not related to a halt of the related security"
      },
      {
        "value": "Y",
        "symbolicName": "RelatedToSecurityHalt",
        "description": "Halt was due to related security being halted"
      }
    ]
  },
  {
    "tag": "330",
    "name": "BuyVolume",
    "type": "Qty",
    "description": "Number of shares bought."
  },
  {
    "tag": "331",
    "name": "SellVolume",
    "type": "Qty",
    "description": "Number of shares sold."
  },
  {
    "tag": "332",
    "name": "HighPx",
    "type": "Price",
    "description": "Represents an indication of the high end of the price range for a security prior to the open or reopen"
  },
  {
    "tag": "333",
    "name": "LowPx",
    "type": "Price",
    "description": "Represents an indication of the low end of the price range for a security prior to the open or reopen"
  },
  {
    "tag": "334",
    "name": "Adjustment",
    "type": "int",
    "description": "Identifies the type of adjustment.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Cancel",
        "description": "Cancel"
      },
      {
        "value": "2",
        "symbolicName": "Error",
        "description": "Error"
      },
      {
        "value": "3",
        "symbolicName": "Correction",
        "description": "Correction"
      }
    ]
  },
  {
    "tag": "335",
    "name": "TradSesReqID",
    "type": "String",
    "description": "Unique ID of a Trading Session Status message."
  },
  {
    "tag": "336",
    "name": "TradingSessionID",
    "type": "String",
    "description": "Identifier for Trading Session\nCan be used to represent a specific market trading session (e.g. \"PRE-OPEN\", \"CROSS_2\", \"AFTER-HOURS\", \"TOSTNET1\", \"TOSTNET2\", etc).\nValues should be bi-laterally agreed to between counterparties."
  },
  {
    "tag": "337",
    "name": "ContraTrader",
    "type": "String",
    "description": "Identifies the trader (e.g. \"badge number\") of the ContraBroker."
  },
  {
    "tag": "338",
    "name": "TradSesMethod",
    "type": "int",
    "description": "Method of trading",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Electronic",
        "description": "Electronic"
      },
      {
        "value": "2",
        "symbolicName": "OpenOutcry",
        "description": "Open Outcry"
      },
      {
        "value": "3",
        "symbolicName": "TwoParty",
        "description": "Two Party"
      }
    ]
  },
  {
    "tag": "339",
    "name": "TradSesMode",
    "type": "int",
    "description": "Trading Session Mode",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Testing",
        "description": "Testing"
      },
      {
        "value": "2",
        "symbolicName": "Simulated",
        "description": "Simulated"
      },
      {
        "value": "3",
        "symbolicName": "Production",
        "description": "Production"
      }
    ]
  },
  {
    "tag": "340",
    "name": "TradSesStatus",
    "type": "int",
    "description": "State of the trading session.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Halted",
        "description": "Halted"
      },
      {
        "value": "2",
        "symbolicName": "Open",
        "description": "Open"
      },
      {
        "value": "3",
        "symbolicName": "Closed",
        "description": "Closed"
      },
      {
        "value": "4",
        "symbolicName": "PreOpen",
        "description": "Pre-Open"
      },
      {
        "value": "5",
        "symbolicName": "PreClose",
        "description": "Pre-Close"
      }
    ]
  },
  {
    "tag": "341",
    "name": "TradSesStartTime",
    "type": "UTCTimestamp",
    "description": "Starting time of the trading session"
  },
  {
    "tag": "342",
    "name": "TradSesOpenTime",
    "type": "UTCTimestamp",
    "description": "Time of the opening of the trading session"
  },
  {
    "tag": "343",
    "name": "TradSesPreCloseTime",
    "type": "UTCTimestamp",
    "description": "Time of the pre-closed of the trading session"
  },
  {
    "tag": "344",
    "name": "TradSesCloseTime",
    "type": "UTCTimestamp",
    "description": "Closing time of the trading session"
  },
  {
    "tag": "345",
    "name": "TradSesEndTime",
    "type": "UTCTimestamp",
    "description": "End time of the trading session"
  },
  {
    "tag": "346",
    "name": "NumberOfOrders",
    "type": "int",
    "description": "Number of orders in the market."
  },
  {
    "tag": "347",
    "name": "MessageEncoding",
    "type": "String",
    "description": "Type of message encoding (non-ASCII (non-English) characters) used in a message’s \"Encoded\" fields.",
    "enum": [
      {
        "value": "EUC-JP",
        "symbolicName": "EUCJP",
        "description": "(for using EUC)"
      },
      {
        "value": "ISO-2022-JP",
        "symbolicName": "ISO2022JP",
        "description": "(for using JIS)"
      },
      {
        "value": "Shift_JIS",
        "symbolicName": "ShiftJIS",
        "description": "(for using SJIS)"
      },
      {
        "value": "UTF-8",
        "symbolicName": "UTF8",
        "description": "(for using Unicode)"
      }
    ]
  },
  {
    "tag": "348",
    "name": "EncodedIssuerLen",
    "type": "Length",
    "description": "Byte length of encoded (non-ASCII characters) EncodedIssuer field."
  },
  {
    "tag": "349",
    "name": "EncodedIssuer",
    "type": "data",
    "description": "Encoded (non-ASCII characters) representation of the Issuer field in the encoded format specified via the MessageEncoding field. If used, the ASCII (English) representation should also be specified in the Issuer field."
  },
  {
    "tag": "350",
    "name": "EncodedSecurityDescLen",
    "type": "Length",
    "description": "Byte length of encoded (non-ASCII characters) EncodedSecurityDesc field."
  },
  {
    "tag": "351",
    "name": "EncodedSecurityDesc",
    "type": "data",
    "description": "Encoded (non-ASCII characters) representation of the SecurityDesc field in the encoded format specified via the MessageEncoding field. If used, the ASCII (English) representation should also be specified in the SecurityDesc field."
  },
  {
    "tag": "352",
    "name": "EncodedListExecInstLen",
    "type": "Length",
    "description": "Byte length of encoded (non-ASCII characters) EncodedListExecInst field."
  },
  {
    "tag": "353",
    "name": "EncodedListExecInst",
    "type": "data",
    "description": "Encoded (non-ASCII characters) representation of the ListExecInst field in the encoded format specified via the MessageEncoding field. If used, the ASCII (English) representation should also be specified in the ListExecInst field."
  },
  {
    "tag": "354",
    "name": "EncodedTextLen",
    "type": "Length",
    "description": "Byte length of encoded (non-ASCII characters) EncodedText field."
  },
  {
    "tag": "355",
    "name": "EncodedText",
    "type": "data",
    "description": "Encoded (non-ASCII characters) representation of the Text field in the encoded format specified via the MessageEncoding field. If used, the ASCII (English) representation should also be specified in the Text field."
  },
  {
    "tag": "356",
    "name": "EncodedSubjectLen",
    "type": "Length",
    "description": "Byte length of encoded (non-ASCII characters) EncodedSubject field."
  },
  {
    "tag": "357",
    "name": "EncodedSubject",
    "type": "data",
    "description": "Encoded (non-ASCII characters) representation of the Subject field in the encoded format specified via the MessageEncoding field. If used, the ASCII (English) representation should also be specified in the Subject field."
  },
  {
    "tag": "358",
    "name": "EncodedHeadlineLen",
    "type": "Length",
    "description": "Byte length of encoded (non-ASCII characters) EncodedHeadline field."
  },
  {
    "tag": "359",
    "name": "EncodedHeadline",
    "type": "data",
    "description": "Encoded (non-ASCII characters) representation of the Headline field in the encoded format specified via the MessageEncoding field. If used, the ASCII (English) representation should also be specified in the Headline field."
  },
  {
    "tag": "360",
    "name": "EncodedAllocTextLen",
    "type": "Length",
    "description": "Byte length of encoded (non-ASCII characters) EncodedAllocText field."
  },
  {
    "tag": "361",
    "name": "EncodedAllocText",
    "type": "data",
    "description": "Encoded (non-ASCII characters) representation of the AllocText field in the encoded format specified via the MessageEncoding field. If used, the ASCII (English) representation should also be specified in the AllocText field."
  },
  {
    "tag": "362",
    "name": "EncodedUnderlyingIssuerLen",
    "type": "Length",
    "description": "Byte length of encoded (non-ASCII characters) EncodedUnderlyingIssuer field."
  },
  {
    "tag": "363",
    "name": "EncodedUnderlyingIssuer",
    "type": "data",
    "description": "Encoded (non-ASCII characters) representation of the UnderlyingIssuer field in the encoded format specified via the MessageEncoding field. If used, the ASCII (English) representation should also be specified in the UnderlyingIssuer field."
  },
  {
    "tag": "364",
    "name": "EncodedUnderlyingSecurityDescLen",
    "type": "Length",
    "description": "Byte length of encoded (non-ASCII characters) EncodedUnderlyingSecurityDesc field."
  },
  {
    "tag": "365",
    "name": "EncodedUnderlyingSecurityDesc",
    "type": "data",
    "description": "Encoded (non-ASCII characters) representation of the UnderlyingSecurityDesc field in the encoded format specified via the MessageEncoding field. If used, the ASCII (English) representation should also be specified in the UnderlyingSecurityeDesc field."
  },
  {
    "tag": "366",
    "name": "AllocPrice",
    "type": "Price",
    "description": "Executed price for an AllocAccount entry used when using \"executed price\" vs. \"average price\" allocations (e.g. Japan)."
  },
  {
    "tag": "367",
    "name": "QuoteSetValidUntilTime",
    "type": "UTCTimestamp",
    "description": "Indicates expiration time of this particular QuoteSet (always expressed in UTC (Universal Time Coordinated, also known as \"GMT\")"
  },
  {
    "tag": "368",
    "name": "QuoteEntryRejectReason",
    "type": "int",
    "description": "Reason Quote Entry was rejected:",
    "enum": [
      {
        "value": "1",
        "symbolicName": "UnknownSymbol",
        "description": "Unknown symbol (Security)"
      },
      {
        "value": "2",
        "symbolicName": "Exchange",
        "description": "Exchange (Security) closed"
      },
      {
        "value": "3",
        "symbolicName": "QuoteExceedsLimit",
        "description": "Quote exceeds limit"
      },
      {
        "value": "4",
        "symbolicName": "TooLateToEnter",
        "description": "Too late to enter"
      },
      {
        "value": "5",
        "symbolicName": "UnknownQuote",
        "description": "Unknown Quote"
      },
      {
        "value": "6",
        "symbolicName": "DuplicateQuote",
        "description": "Duplicate Quote"
      },
      {
        "value": "7",
        "symbolicName": "InvalidBidAskSpread",
        "description": "Invalid bid/ask spread"
      },
      {
        "value": "8",
        "symbolicName": "InvalidPrice",
        "description": "Invalid price"
      },
      {
        "value": "9",
        "symbolicName": "NotAuthorizedToQuoteSecurity",
        "description": "Not authorized to quote security"
      }
    ]
  },
  {
    "tag": "369",
    "name": "LastMsgSeqNumProcessed",
    "type": "int",
    "description": "The last MsgSeqNum value received and processed. Can be specified on every message sent. Useful for detecting a backlog with a counterparty."
  },
  {
    "tag": "370",
    "name": "OnBehalfOfSendingTime",
    "type": "UTCTimestamp",
    "description": "Used when a message is sent via a \"hub\" or \"service bureau\". If A sends to Q (the hub) who then sends to B via a separate FIX session, then when Q sends to B the value of this field should represent the SendingTime on the message A sent to Q. (always expressed in UTC (Universal Time Coordinated, also known as \"GMT\")"
  },
  {
    "tag": "371",
    "name": "RefTagID",
    "type": "int",
    "description": "The tag number of the FIX field being referenced."
  },
  {
    "tag": "372",
    "name": "RefMsgType",
    "type": "String",
    "description": "The MsgType of the FIX message being referenced."
  },
  {
    "tag": "373",
    "name": "SessionRejectReason",
    "type": "int",
    "description": "Code to identify reason for a session-level Reject message.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "InvalidTagNumber",
        "description": "Invalid tag number"
      },
      {
        "value": "1",
        "symbolicName": "RequiredTagMissing",
        "description": "Required tag missing"
      },
      {
        "value": "10",
        "symbolicName": "SendingTimeAccuracyProblem",
        "description": "SendingTime accuracy problem"
      },
      {
        "value": "11",
        "symbolicName": "InvalidMsgType",
        "description": "Invalid MsgType"
      },
      {
        "value": "2",
        "symbolicName": "TagNotDefinedForThisMessageType",
        "description": "Tag not defined for this message type"
      },
      {
        "value": "3",
        "symbolicName": "UndefinedTag",
        "description": "Undefined Tag"
      },
      {
        "value": "4",
        "symbolicName": "TagSpecifiedWithoutAValue",
        "description": "Tag specified without a value"
      },
      {
        "value": "5",
        "symbolicName": "ValueIsIncorrect",
        "description": "Value is incorrect (out of range) for this tag"
      },
      {
        "value": "6",
        "symbolicName": "IncorrectDataFormatForValue",
        "description": "Incorrect data format for value"
      },
      {
        "value": "7",
        "symbolicName": "DecryptionProblem",
        "description": "Decryption problem"
      },
      {
        "value": "8",
        "symbolicName": "SignatureProblem",
        "description": "Signature problem"
      },
      {
        "value": "9",
        "symbolicName": "CompIDProblem",
        "description": "CompID problem"
      }
    ]
  },
  {
    "tag": "374",
    "name": "BidRequestTransType",
    "type": "char",
    "description": "Identifies the Bid Request message type.",
    "enum": [
      {
        "value": "C",
        "symbolicName": "Cancel",
        "description": "Cancel"
      },
      {
        "value": "N",
        "symbolicName": "New",
        "description": "New"
      }
    ]
  },
  {
    "tag": "375",
    "name": "ContraBroker",
    "type": "String",
    "description": "Identifies contra broker. Standard NASD market-maker mnemonic is preferred."
  },
  {
    "tag": "376",
    "name": "ComplianceID",
    "type": "String",
    "description": "ID used to represent this transaction for compliance purposes (e.g. OATS reporting)."
  },
  {
    "tag": "377",
    "name": "SolicitedFlag",
    "type": "Boolean",
    "description": "Indicates whether or not the order was solicited.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "WasNotSolicited",
        "description": "Was not solicited"
      },
      {
        "value": "Y",
        "symbolicName": "WasSolicited",
        "description": "Was solcitied"
      }
    ]
  },
  {
    "tag": "378",
    "name": "ExecRestatementReason",
    "type": "int",
    "description": "Code to identify reason for an ExecutionRpt message sent with ExecType=Restated or used when communicating an unsolicited cancel.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "GTCorporateAction",
        "description": "GT Corporate action"
      },
      {
        "value": "1",
        "symbolicName": "GTRenewal",
        "description": "GT renewal / restatement (no corporate action)"
      },
      {
        "value": "2",
        "symbolicName": "VerbalChange",
        "description": "Verbal change"
      },
      {
        "value": "3",
        "symbolicName": "RepricingOfOrder",
        "description": "Repricing of order"
      },
      {
        "value": "4",
        "symbolicName": "BrokerOption",
        "description": "Broker option"
      },
      {
        "value": "5",
        "symbolicName": "PartialDeclineOfOrderQty",
        "description": "Partial decline of OrderQty (e.g. exchange-initiated partial cancel)"
      }
    ]
  },
  {
    "tag": "379",
    "name": "BusinessRejectRefID",
    "type": "String",
    "description": "The value of the business-level \"ID\" field on the message being referenced."
  },
  {
    "tag": "380",
    "name": "BusinessRejectReason",
    "type": "int",
    "description": "Code to identify reason for a Business Message Reject message.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Other",
        "description": "Other"
      },
      {
        "value": "1",
        "symbolicName": "UnknownID",
        "description": "Unkown ID"
      },
      {
        "value": "2",
        "symbolicName": "UnknownSecurity",
        "description": "Unknown Security"
      },
      {
        "value": "3",
        "symbolicName": "UnsupportedMessageType",
        "description": "Unsupported Message Type"
      },
      {
        "value": "4",
        "symbolicName": "ApplicationNotAvailable",
        "description": "Application not available"
      },
      {
        "value": "5",
        "symbolicName": "ConditionallyRequiredFieldMissing",
        "description": "Conditionally Required Field Missing"
      }
    ]
  },
  {
    "tag": "381",
    "name": "GrossTradeAmt",
    "type": "Amt",
    "description": "Total amount traded (e.g. CumQty * AvgPx) expressed in units of currency."
  },
  {
    "tag": "382",
    "name": "NoContraBrokers",
    "type": "int",
    "description": "The number of ContraBroker entries."
  },
  {
    "tag": "383",
    "name": "MaxMessageSize",
    "type": "int",
    "description": "Maximum number of bytes supported for a single message."
  },
  {
    "tag": "384",
    "name": "NoMsgTypes",
    "type": "int",
    "description": "Number of MsgTypes in repeating group."
  },
  {
    "tag": "385",
    "name": "MsgDirection",
    "type": "char",
    "description": "Specifies the direction of the messsage.",
    "enum": [
      {
        "value": "R",
        "symbolicName": "Receive",
        "description": "Receive"
      },
      {
        "value": "S",
        "symbolicName": "Send",
        "description": "Send"
      }
    ]
  },
  {
    "tag": "386",
    "name": "NoTradingSessions",
    "type": "int",
    "description": "Number of TradingSessionIDs in repeating group."
  },
  {
    "tag": "387",
    "name": "TotalVolumeTraded",
    "type": "Qty",
    "description": "Total volume (quantity) traded."
  },
  {
    "tag": "388",
    "name": "DiscretionInst",
    "type": "char",
    "description": "Code to identify the price a DiscretionOffset is related to and should be mathematically added to.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "RelatedToDisplayedPrice",
        "description": "Related to displayed price"
      },
      {
        "value": "1",
        "symbolicName": "RelatedToMarketPrice",
        "description": "Related to market price"
      },
      {
        "value": "2",
        "symbolicName": "RelatedToPrimaryPrice",
        "description": "Related to primary price"
      },
      {
        "value": "3",
        "symbolicName": "RelatedToLocalPrimaryPrice",
        "description": "Related to local primary price"
      },
      {
        "value": "4",
        "symbolicName": "RelatedToMidpointPrice",
        "description": "Related to midpoint price"
      },
      {
        "value": "5",
        "symbolicName": "RelatedToLastTradePrice",
        "description": "Related to last trade price"
      }
    ]
  },
  {
    "tag": "389",
    "name": "DiscretionOffset",
    "type": "PriceOffset",
    "description": "Amount (signed) added to the \"related to\" price specified via DiscretionInst."
  },
  {
    "tag": "390",
    "name": "BidID",
    "type": "String",
    "description": "Unique identifier for Bid Response as assigned by broker. Uniqueness must be guaranteed within a single trading day."
  },
  {
    "tag": "391",
    "name": "ClientBidID",
    "type": "String",
    "description": "Unique identifier for a Bid Request as assigned by institution. Uniqueness must be guaranteed within a single trading day."
  },
  {
    "tag": "392",
    "name": "ListName",
    "type": "String",
    "description": "Descriptive name for list order."
  },
  {
    "tag": "393",
    "name": "TotalNumSecurities",
    "type": "int",
    "description": "Total number of securities."
  },
  {
    "tag": "394",
    "name": "BidType",
    "type": "int",
    "description": "Code to identify the type of Bid Request."
  },
  {
    "tag": "395",
    "name": "NumTickets",
    "type": "int",
    "description": "Total number of tickets."
  },
  {
    "tag": "396",
    "name": "SideValue1",
    "type": "Amt",
    "description": "Amounts in currency"
  },
  {
    "tag": "397",
    "name": "SideValue2",
    "type": "Amt",
    "description": "Amounts in currency"
  },
  {
    "tag": "398",
    "name": "NoBidDescriptors",
    "type": "int",
    "description": "Number of BidDescriptor entries."
  },
  {
    "tag": "399",
    "name": "BidDescriptorType",
    "type": "int",
    "description": "Code to identify the type of BidDescriptor."
  },
  {
    "tag": "400",
    "name": "BidDescriptor",
    "type": "String",
    "description": "BidDescriptor value. Usage depends upon BidDescriptorType."
  },
  {
    "tag": "401",
    "name": "SideValueInd",
    "type": "int",
    "description": "Code to identify which \"SideValue\" the value refers to. SideValue1 and SideValue2 are used as opposed to Buy or Sell so that the basket can be quoted either way as Buy or Sell."
  },
  {
    "tag": "402",
    "name": "LiquidityPctLow",
    "type": "float",
    "description": "Liquidity indicator or lower limit if TotalNumSecurities > 1. Represented as a percentage."
  },
  {
    "tag": "403",
    "name": "LiquidityPctHigh",
    "type": "float",
    "description": "Upper liquidity indicator if TotalNumSecurities > 1. Represented as a percentage."
  },
  {
    "tag": "404",
    "name": "LiquidityValue",
    "type": "Amt",
    "description": "Value between LiquidityPctLow and LiquidityPctHigh in Currency"
  },
  {
    "tag": "405",
    "name": "EFPTrackingError",
    "type": "float",
    "description": "Eg Used in EFP trades 12% (EFP – Exchange for Physical ). Represented as a percentage."
  },
  {
    "tag": "406",
    "name": "FairValue",
    "type": "Amt",
    "description": "Used in EFP trades"
  },
  {
    "tag": "407",
    "name": "OutsideIndexPct",
    "type": "float",
    "description": "Used in EFP trades. Represented as a percentage."
  },
  {
    "tag": "408",
    "name": "ValueOfFutures",
    "type": "Amt",
    "description": "Used in EFP trades"
  },
  {
    "tag": "409",
    "name": "LiquidityIndType",
    "type": "int",
    "description": "Code to identify the type of liquidity indicator.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "FiveDayMovingAverage",
        "description": "5 day moving average"
      },
      {
        "value": "2",
        "symbolicName": "TwentyDayMovingAverage",
        "description": "20 day moving average"
      },
      {
        "value": "3",
        "symbolicName": "NormalMarketSize",
        "description": "Normal Market Size"
      },
      {
        "value": "4",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "410",
    "name": "WtAverageLiquidity",
    "type": "float",
    "description": "Overall weighted average liquidity expressed as a % of average daily volume. Represented as a percentage."
  },
  {
    "tag": "411",
    "name": "ExchangeForPhysical",
    "type": "Boolean",
    "description": "Indicates whether or not to exchange for phsyical.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "False",
        "description": "False"
      },
      {
        "value": "Y",
        "symbolicName": "True",
        "description": "True"
      }
    ]
  },
  {
    "tag": "412",
    "name": "OutMainCntryUIndex",
    "type": "Amt",
    "description": "Value of stocks in Currency"
  },
  {
    "tag": "413",
    "name": "CrossPercent",
    "type": "float",
    "description": "Percentage of program that crosses in Currency. Represented as a percentage."
  },
  {
    "tag": "414",
    "name": "ProgRptReqs",
    "type": "int",
    "description": "Code to identify the desired frequency of progress reports.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "BuySideRequests",
        "description": "BuySide explicitly requests status using StatusRequest (Default) The sell-side firm can however, send a DONE status List Status Response in an unsolicited fashion"
      },
      {
        "value": "2",
        "symbolicName": "SellSideSends",
        "description": "SellSide periodically sends status using ListStatus. Period optionally specified in ProgressPeriod"
      },
      {
        "value": "3",
        "symbolicName": "RealTimeExecutionReports",
        "description": "Real-time execution reports (to be discouraged)"
      }
    ]
  },
  {
    "tag": "415",
    "name": "ProgPeriodInterval",
    "type": "int",
    "description": "Time in minutes between each ListStatus report sent by SellSide. Zero means don’t send status."
  },
  {
    "tag": "416",
    "name": "IncTaxInd",
    "type": "int",
    "description": "Code to represent whether value is net (inclusive of tax) or gross.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Net",
        "description": "Net"
      },
      {
        "value": "2",
        "symbolicName": "Gross",
        "description": "Gross"
      }
    ]
  },
  {
    "tag": "417",
    "name": "NumBidders",
    "type": "int",
    "description": "Indicates the total number of bidders on the list"
  },
  {
    "tag": "418",
    "name": "TradeType",
    "type": "char",
    "description": "Code to represent the type of trade.",
    "enum": [
      {
        "value": "A",
        "symbolicName": "Agency",
        "description": "Agency"
      },
      {
        "value": "G",
        "symbolicName": "VWAPGuarantee",
        "description": "VWAP Guarantee"
      },
      {
        "value": "J",
        "symbolicName": "GuaranteedClose",
        "description": "Guaranteed Close"
      },
      {
        "value": "R",
        "symbolicName": "RiskTrade",
        "description": "Risk Trade"
      }
    ]
  },
  {
    "tag": "419",
    "name": "BasisPxType",
    "type": "char",
    "description": "Code to represent the basis price type.",
    "enum": [
      {
        "value": "2",
        "symbolicName": "ClosingPriceAtMorningSession",
        "description": "Closing Price at morning session"
      },
      {
        "value": "3",
        "symbolicName": "ClosingPrice",
        "description": "Closing Price"
      },
      {
        "value": "4",
        "symbolicName": "CurrentPrice",
        "description": "Current price"
      },
      {
        "value": "5",
        "symbolicName": "SQ",
        "description": "SQ"
      },
      {
        "value": "6",
        "symbolicName": "VWAPThroughADay",
        "description": "VWAP through a day"
      },
      {
        "value": "7",
        "symbolicName": "VWAPThroughAMorningSession",
        "description": "VWAP through a morning session"
      },
      {
        "value": "8",
        "symbolicName": "VWAPThroughAnAfternoonSession",
        "description": "VWAP through an afternoon session"
      },
      {
        "value": "9",
        "symbolicName": "VWAPThroughADayExcept",
        "description": "VWAP through a day except YORI"
      },
      {
        "value": "A",
        "symbolicName": "VWAPThroughAMorningSessionExcept",
        "description": "VWAP through a morning session except YORI"
      },
      {
        "value": "B",
        "symbolicName": "VWAPThroughAnAfternoonSessionExcept",
        "description": "VWAP through an afternoon session except YORI"
      },
      {
        "value": "C",
        "symbolicName": "Strike",
        "description": "Strike"
      },
      {
        "value": "D",
        "symbolicName": "Open",
        "description": "Open"
      },
      {
        "value": "Z",
        "symbolicName": "Others",
        "description": "Others"
      }
    ]
  },
  {
    "tag": "420",
    "name": "NoBidComponents",
    "type": "int",
    "description": "Indicates the number of list entries."
  },
  {
    "tag": "421",
    "name": "Country",
    "type": "String",
    "description": "ISO Country Code in field"
  },
  {
    "tag": "422",
    "name": "TotNoStrikes",
    "type": "int",
    "description": "Total number of strike price entries across all messages. Should be the sum of all NoStrikes in each message that has repeating strike price entries related to the same ListID. Used to support fragmentation."
  },
  {
    "tag": "423",
    "name": "PriceType",
    "type": "int",
    "description": "Code to represent the price type.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Percentage",
        "description": "Percentage"
      },
      {
        "value": "2",
        "symbolicName": "PerUnit",
        "description": "per share (e.g. cents per share)"
      },
      {
        "value": "3",
        "symbolicName": "FixedAmount",
        "description": "Fixed Amount (absolute value)"
      }
    ]
  },
  {
    "tag": "424",
    "name": "DayOrderQty",
    "type": "Qty",
    "description": "For GT orders, the OrderQty less all shares (adjusted for stock splits) that traded on previous days. DayOrderQty = OrderQty – (CumQty - DayCumQty)"
  },
  {
    "tag": "425",
    "name": "DayCumQty",
    "type": "Qty",
    "description": "The number of shares on a GT order that have traded today."
  },
  {
    "tag": "426",
    "name": "DayAvgPx",
    "type": "Price",
    "description": "The average price of shares on a GT order that have traded today."
  },
  {
    "tag": "427",
    "name": "GTBookingInst",
    "type": "int",
    "description": "Code to identify whether to book out executions on a part-filled GT order on the day of execution or to accumulate.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "BookOutAllTradesOnDayOfExecution",
        "description": "book out all trades on day of execution"
      },
      {
        "value": "1",
        "symbolicName": "AccumulateUntilFilledOrExpired",
        "description": "accumulate executions until order is filled or expires"
      },
      {
        "value": "2",
        "symbolicName": "AccumulateUntilVerballlyNotifiedOtherwise",
        "description": "accumulate until verbally notified otherwise"
      }
    ]
  },
  {
    "tag": "428",
    "name": "NoStrikes",
    "type": "int",
    "description": "Number of list strike price entries."
  },
  {
    "tag": "429",
    "name": "ListStatusType",
    "type": "int",
    "description": "Code to represent the price type."
  },
  {
    "tag": "430",
    "name": "NetGrossInd",
    "type": "int",
    "description": "Code to represent whether value is net (inclusive of tax) or gross.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Net",
        "description": "Net"
      },
      {
        "value": "2",
        "symbolicName": "Gross",
        "description": "Gross"
      }
    ]
  },
  {
    "tag": "431",
    "name": "ListOrderStatus",
    "type": "int",
    "description": "Code to represent the status of a list order."
  },
  {
    "tag": "432",
    "name": "ExpireDate",
    "type": "LocalMktDate",
    "description": "Date of order expiration (last day the order can trade), always expressed in terms of the local market date. The time at which the order expires is determined by the local market’s business practices"
  },
  {
    "tag": "433",
    "name": "ListExecInstType",
    "type": "char",
    "description": "Identifies the type of ListExecInst.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Immediate",
        "description": "Immediate"
      },
      {
        "value": "2",
        "symbolicName": "WaitForInstruction",
        "description": "Wait for Execute Instruction (e.g. a List Execute message or phone call before proceeding with execution of the list)"
      }
    ]
  },
  {
    "tag": "434",
    "name": "CxlRejResponseTo",
    "type": "char",
    "description": "Identifies the type of request that a Cancel Reject is in response to.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "OrderCancelRequest",
        "description": "Order Cancel Request"
      },
      {
        "value": "2",
        "symbolicName": "OrderCancel",
        "description": "Order Cancel/Replace Request"
      }
    ]
  },
  {
    "tag": "435",
    "name": "UnderlyingCouponRate",
    "type": "float",
    "description": "Underlying security’s CouponRate.\nSee CouponRate field for description"
  },
  {
    "tag": "436",
    "name": "UnderlyingContractMultiplier",
    "type": "float",
    "description": "Underlying security’s ContractMultiplier.\nSee ContractMultiplier field for description"
  },
  {
    "tag": "437",
    "name": "ContraTradeQty",
    "type": "Qty",
    "description": "Quantity traded with the ContraBroker."
  },
  {
    "tag": "438",
    "name": "ContraTradeTime",
    "type": "UTCTimestamp",
    "description": "Identifes the time of the trade with the ContraBroker. (always expressed in UTC (Universal Time Coordinated, also known as \"GMT\")"
  },
  {
    "tag": "439",
    "name": "ClearingFirm",
    "type": "String",
    "description": "Firm that will clear the trade. Used if different from the executing firm."
  },
  {
    "tag": "440",
    "name": "ClearingAccount",
    "type": "String",
    "description": "Supplemental accounting information forwared to clearing house/firm."
  },
  {
    "tag": "441",
    "name": "LiquidityNumSecurities",
    "type": "int",
    "description": "Number of Securites between LiquidityPctLow and LiquidityPctHigh in Currency."
  },
  {
    "tag": "442",
    "name": "MultiLegReportingType",
    "type": "char",
    "description": "Used to indicate what an Execution Report represents (e.g. used with multi-leg securiteis, such as option strategies, spreads, etc.).",
    "enum": [
      {
        "value": "1",
        "symbolicName": "SingleSecurity",
        "description": "Single Security (default if not specified)"
      },
      {
        "value": "2",
        "symbolicName": "IndividualLegOfAMultiLegSecurity",
        "description": "Individual leg of a multi-leg security"
      },
      {
        "value": "3",
        "symbolicName": "MultiLegSecurity",
        "description": "Multi-leg security"
      }
    ]
  },
  {
    "tag": "443",
    "name": "StrikeTime",
    "type": "UTCTimestamp",
    "description": "The time at which current market prices are used to determine the value of a basket."
  },
  {
    "tag": "444",
    "name": "ListStatusText",
    "type": "String",
    "description": "Free format text string related to List Status."
  },
  {
    "tag": "445",
    "name": "EncodedListStatusTextLen",
    "type": "Length",
    "description": "Byte length of encoded (non-ASCII characters) EncodedListStatusText field."
  },
  {
    "tag": "446",
    "name": "EncodedListStatusText",
    "type": "data",
    "description": "Encoded (non-ASCII characters) representation of the ListStatusText field in the encoded format specified via the MessageEncoding field. If used, the ASCII (English) representation should also be specified in the ListStatusText field."
  }
]
